import angrybirds from "../Assets/images/Game-logo/angry_birds.png";
import archrymaster from "../Assets/images/Game-logo/archery_master_3d.png";
import assetto from "../Assets/images/Game-logo/assetto_corsa.png";
import barbirgirl from "../Assets/images/Game-logo/barbie_girls_games.png";
import basketblitz from "../Assets/images/Game-logo/basket_blitz.png";
import basketchaps from "../Assets/images/Game-logo/basket_champs.png";
import bikeblitz from "../Assets/images/Game-logo/bike_blitz_game.png";
import blockblast from "../Assets/images/Game-logo/block_blast.png";
import blockmatch from "../Assets/images/Game-logo/block_match.png";
import bowling from "../Assets/images/Game-logo/bowling.png";
import breakline from "../Assets/images/Game-logo/break_the_line.png";
import bubbleshooter from "../Assets/images/Game-logo/bubble_pop_blast.png";
import callofduty from "../Assets/images/Game-logo/war_duty.png";
import christmaspreparation from "../Assets/images/Game-logo/christmas_preparation.png";
import cluckroad from "../Assets/images/Game-logo/cluck_and_road.png";
import colorring from "../Assets/images/Game-logo/color_rings_puzzle.png";
import cokkingfever from "../Assets/images/Game-logo/cooking_fever.png";
import cosmicglide from "../Assets/images/Game-logo/cosmic_glide.png";
import counterstrike from "../Assets/images/Game-logo/counter_strike_2.png";
import cubes from "../Assets/images/Game-logo/cubes_2048.png";
import dadyhelper from "../Assets/images/Game-logo/daddy's_little_helper.png";
import dollcakemaker from "../Assets/images/Game-logo/doll_cake_maker.png";
import drawclimber from "../Assets/images/Game-logo/draw_climber.png";
import duckdrive from "../Assets/images/Game-logo/duck_&_dive.png";
import dunkline from "../Assets/images/Game-logo/dunk_line.png";
import energyball from "../Assets/images/Game-logo/energy_ball.png";
import flightdash from "../Assets/images/Game-logo/flight_dash.png";
import footballsoccer from "../Assets/images/Game-logo/football_soccer.png";
import forzahorizon from "../Assets/images/Game-logo/forza_horizon_5.png";
import fuzzbugs from "../Assets/images/Game-logo/fuzz_bugs.png";
import galaxy from "../Assets/images/Game-logo/galexy_atteck_shooting_games.png";
import geometry from "../Assets/images/Game-logo/geometry_dash.png";
import geometrylite from "../Assets/images/Game-logo/geometry_dash_lite.png";
import gigglebarbie from "../Assets/images/Game-logo/giggle_babies_toddler_care.png";
import hexaquest from "../Assets/images/Game-logo/hexa_quest_block_puzzle.png";
import hillclimb from "../Assets/images/Game-logo/hill_climb_racing_2.png";
import hotlava from "../Assets/images/Game-logo/hot_lava_volcano_game.png";
import icytower from "../Assets/images/Game-logo/icy_tower.png";
// import jungleadventure from "../Assets/images/Game-logo/jungle_adventure.png";
import knifehit from "../Assets/images/Game-logo/knife_hit.png";
import madalincars from "../Assets/images/Game-logo/madalin_cars.png";
import magicprincess from "../Assets/images/Game-logo/magic_princess_dress_up.png";
import magictiles from "../Assets/images/Game-logo/magic_tiles_3.png";
import manicminer from "../Assets/images/Game-logo/manic_miner_spectrum.png";
import matchmaster from "../Assets/images/Game-logo/match_master.png";
import minimilitia from "../Assets/images/Game-logo/mini_army_fight.png";
import monster from "../Assets/images/Game-logo/monster_jam_steel_titans_2.png";
import motox3 from "../Assets/images/Game-logo/moto_x3m.png";
import mybabycare from "../Assets/images/Game-logo/my_baby_care.png";
import mysticmatch from "../Assets/images/Game-logo/mystic_match.png";
import ninjaslice from "../Assets/images/Game-logo/ninja_slice.png";
import pingpong from "../Assets/images/Game-logo/ping_pong_table_tennis.png";
import pixelshuffle from "../Assets/images/Game-logo/pixel_shuffle.png";
import policesprinter from "../Assets/images/Game-logo/police_sprinter.png";
import princessdressup from "../Assets/images/Game-logo/princess_dress_up.png";
import princessfrosty from "../Assets/images/Game-logo/princess_frosty_new_years.png";
import redball from "../Assets/images/Game-logo/red_ball_4.png";
import rescuethefish from "../Assets/images/Game-logo/rescue_the_fish.png";
import returnman from "../Assets/images/Game-logo/return_man_2.png";
import savethecowboy from "../Assets/images/Game-logo/save_the_cowboy.png";
import soccerlegends from "../Assets/images/Game-logo/soccer_legends_2021.png";
import solitairs from "../Assets/images/Game-logo/solitaire.png";
import steeringmaster from "../Assets/images/Game-logo/steering_master.png";
import stickarcher from "../Assets/images/Game-logo/stickman_archer.png";
import subwaysurf from "../Assets/images/Game-logo/subway_surfers.png";
import supermario from "../Assets/images/Game-logo/super_run.png";
import shushichef from "../Assets/images/Game-logo/sushi_chef.png";
import tailtrash from "../Assets/images/Game-logo/tail_thrash.png";
import targettrimph from "../Assets/images/Game-logo/target_triumph.png";
import templerun from "../Assets/images/Game-logo/temple_run_2.png";
import teris from "../Assets/images/Game-logo/tetris.png";
import thespikecross from "../Assets/images/Game-logo/the_spike_cross.png";
import tinyfishing from "../Assets/images/Game-logo/tiny_fishing.png";
import trafficrush from "../Assets/images/Game-logo/traffic_rush.png";
import warmate from "../Assets/images/Game-logo/warmate_game.png";
import whiskerwood from "../Assets/images/Game-logo/whiskerwood.png";
import worldtour from "../Assets/images/Game-logo/world_tour_game.png";
import zuma from "../Assets/images/Game-logo/zuma.png";
import bannerangry from "../Assets/images/bannerangrybird.png";
import bannersubway from "../Assets/images/bannersubway.png";
import bannerfruit from "../Assets/images/bannerfruitninja.png";
import redplay from "../Assets/images/play-red.svg";
import greenplay from "../Assets/images/play-green.svg";
import buleplay from "../Assets/images/play-bule.svg";

// export const gameImages = [
//   { img: subwaysurf, name: "Subway Surfers", path: "/subwaysurf" },
//   { img: angrybirds, name: "Angry Birds", path: "" },
//   { img: archrymaster, name: "Archery Master 3D", path: "" },
//   { img: assetto, name: "Assetto Corsa", path: "" },
//   { img: barbirgirl, name: "Barbie Girls Games", path: "" },
//   { img: basketblitz, name: "Basket Blitz", path: "" },
//   { img: basketchaps, name: "Basket Champs", path: "" },
//   { img: bikeblitz, name: "Bike Blitz Game", path: "" },
//   { img: blockblast, name: "Block Blast", path: "" },
//   { img: blockmatch, name: "Block Match", path: "" },
//   { img: bowling, name: "Bowling", path: "" },
//   { img: breakline, name: "Break The Line", path: "" },
//   { img: bubbleshooter, name: "Bubble Shooter", path: "" },
//   { img: callofduty, name: "Call Of Duty", path: "" },
//   { img: christmaspreparation, name: "Christmas Preparation", path: "" },
//   { img: cluckroad, name: "Cluck And Road", path: "" },
//   { img: colorring, name: "Color Rings Puzzle", path: "" },
//   { img: cokkingfever, name: "Cooking Fever", path: "" },
//   { img: cosmicglide, name: "Cosmic Glide", path: "" },
//   { img: counterstrike, name: "Counter Strike 2", path: "" },
//   { img: cubes, name: "Cubes 2048", path: "" },
//   { img: dadyhelper, name: "Daddy's Little Helper", path: "" },
//   { img: dollcakemaker, name: "Doll Cake Maker", path: "" },
//   { img: drawclimber, name: "Draw Climber", path: "" },
//   { img: duckdrive, name: "Duck & Dive", path: "" },
//   { img: dunkline, name: "Dunk Line", path: "" },
//   { img: energyball, name: "Energy Ball", path: "" },
//   { img: flightdash, name: "Flight Dash", path: "" },
//   { img: footballsoccer, name: "Football Soccer", path: "" },
//   { img: forzahorizon, name: "Forza Horizon 5", path: "" },
//   { img: fuzzbugs, name: "Fuzz Bugs", path: "" },
//   { img: galaxy, name: "Galaxy Attack-Shooting Games", path: "" },
//   { img: geometry, name: "Geometry Dash", path: "" },
//   { img: geometrylite, name: "Geometry Dash Lite", path: "" },
//   { img: gigglebarbie, name: "Giggle Babies-Toddler Care", path: "" },
//   { img: hexaquest, name: "Hexa Quest-Block Puzzle", path: "" },
//   { img: hillclimb, name: "Hill Climb Racing 2", path: "" },
//   { img: hotlava, name: "Hot Lava Volcano Game", path: "" },
//   { img: icytower, name: "Icy Tower", path: "" },
//   { img: jungleadventure, name: "Jungle Adventure", path: "" },
//   { img: knifehit, name: "Knife Hit", path: "" },
//   { img: madalincars, name: "Madalin Cars", path: "" },
//   { img: magicprincess, name: "Magic Princess-Dress Up", path: "" },
//   { img: magictiles, name: "Magic Tiles 3", path: "" },
//   { img: manicminer, name: "Manic Miner-Spectrum", path: "" },
//   { img: matchmaster, name: "Match Master", path: "" },
//   { img: minimilitia, name: "Mini Militia Game", path: "" },
//   { img: monster, name: "Monster Jam Steel Titans 2", path: "" },
//   { img: motox3, name: "Moto X3M", path: "" },
//   { img: mybabycare, name: "My Baby Care", path: "" },
//   { img: mysticmatch, name: "Mystic Match", path: "" },
//   { img: ninjaslice, name: "Ninja Fruit Slice", path: "" },
//   { img: pingpong, name: "Ping Pong-Table Tennis", path: "" },
//   { img: pixelshuffle, name: "Pixel Shuffle", path: "" },
//   { img: policesprinter, name: "Police Sprinter", path: "" },
//   { img: princessdressup, name: "Princess Dress Up", path: "" },
//   { img: princessfrosty, name: "Princess Frosty New Years", path: "" },
//   { img: redball, name: "Red Ball 4", path: "" },
//   { img: rescuethefish, name: "Rescue The Fish", path: "" },
//   { img: returnman, name: "Return-Man-2", path: "" },
//   { img: savethecowboy, name: "Save The Cowboy", path: "" },
//   { img: soccerlegends, name: "Soccer Legends 2021", path: "" },
//   { img: solitairs, name: "Solitaire", path: "" },
//   { img: steeringmaster, name: "Steering Master", path: "" },
//   { img: stickarcher, name: "Stickman Archer", path: "" },
//   { img: supermario, name: "Super Mario", path: "" },
//   { img: shushichef, name: "Sushi Chef", path: "" },
//   { img: tailtrash, name: "Tail Thrash", path: "" },
//   { img: targettrimph, name: "Target Triumph", path: "" },
//   { img: templerun, name: "Temple Run 2", path: "" },
//   { img: teris, name: "Tetris", path: "" },
//   { img: thespikecross, name: "The Spike Cross", path: "" },
//   { img: tinyfishing, name: "Tiny Fishing", path: "" },
//   { img: trafficrush, name: "Traffic Rush", path: "" },
//   { img: warmate, name: "Wormate Game", path: "" },
//   { img: whiskerwood, name: "Whiskerwood", path: "" },
//   { img: worldtour, name: "World Tour Game", path: "" },
//   { img: zuma, name: "Zuma", path: "" },
// ];

export const gameList = [
  {
    id: "bubbleshooter",
    name: "Bubble Pop Blast",
    img: bubbleshooter,
    banner: require("../Assets/images/banner/bubble_pop_blast.jpg"),
    description: "Shoot bubbles & clear colorful boards!",
    gamePath: "/Games/candy_cascade_quest/index.htm",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Play Bubble Pop Blast Online",
      sections: [
        {
          title: "1. What is Bubble Pop Blast?",
          content:
            "Bubble Pop Blast is a fun and relaxing bubble matching game where you aim, shoot, and pop colorful tiles from the screen. It’s simple to learn and perfect for a quick break or a long session of bubble popping joy. Clear bubbles, rack up points, and enjoy the satisfying chain reactions.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Aim carefully and launch your bubbles to match three or more of the same color. When they connect, they burst and free up space on the board. The challenge grows as the bubbles slowly move downward stay sharp and clear them before they reach the bottom! Smart angles and quick decisions will help you boost your score and advance to tougher stages.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Aim carefully and launch your bubbles to match three or more of the same color. When they connect, they burst and free up space on the board. The challenge grows as the bubbles slowly move downward stay sharp and clear them before they reach the bottom! Smart angles and quick decisions will help you boost your score and advance to tougher stages.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Bubble Pop Blast",
          content:
            "Pop the bubbles before they reach the bottom Match three or more of the same color to clear the board and score big points. Every perfect shot helps you unlock new challenges and improve your aim.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Use your mouse or finger to aim the bubble shooter",
            "Match 3+ bubbles of the same color to pop them",
            "Clear as many bubbles as possible to keep the board from filling",
            "Plan your shots to create combos and earn bonuses",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Bounce bubbles off the walls for tricky angles",
            "Focus on popping large clusters first to keep the board clean",
            "Keep an eye on upcoming bubble colors for better planning",
            "Don’t wait too long  the bubbles slowly move downward!",
          ],
        },
      ],
      features: [
        {
          title: "1. Classic Gameplay with a Fresh Style",
          content:
            "Enjoy the traditional bubble popping fun with a modern visual twist. Smooth controls, colorful bubbles, and satisfying effects make every match feel rewarding and enjoyable.",
        },
        {
          title: "2. Fun for Everyone",
          content:
            "Bubble Pop Blast is designed to be simple enough for new players and exciting for score chasers. Whether you want to relax or challenge yourself, it’s always a great time to pop bubbles.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team focuses on delivering clean design, fair levels, and responsive gameplay  so every shot feels accurate and every win feels earned. Your gaming experience matters to us.",
        },
      ],
    },
  },

  {
    id: "duckdrive",
    name: "Duck & Dive",
    img: duckdrive,
    banner: require("../Assets/images/banner/duck_&_dive.jpg"),
    description: " Dodge obstacles & dive through gaps!",
    gamePath: "/Games/duck_dive_dash/index.html",
    category: "Kids",
    type: "Latest",
    about: {
      heading: "Enjoy Duck & Dive online",
      sections: [
        {
          title: "1. What is Duck & Dive?",
          content:
            "Duck & Dive is a fast-reaction survival game where you must avoid every obstacle coming your way. Stay alert, move quickly, and see how long you can last as the challenge keeps rising. One wrong move and the run ends  can you push your score higher each time?",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Navigate through tight spaces and dodge sudden movements that test your timing. The longer you survive, the more intense the course becomes. Each run is different  quick reactions and smart positioning are the keys to climbing the leaderboard.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Navigate through tight spaces and dodge sudden movements that test your timing. The longer you survive, the more intense the course becomes. Each run is different  quick reactions and smart positioning are the keys to climbing the leaderboard.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Duck & Dive",
          content:
            "Stay alive by dodging barriers, sliding past moving traps, and reacting at lightning speed. The game gets faster step by step, turning every second into a new challenge.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Tap or press to duck under obstacles",
            "Swipe to shift left or right",
            "Keep moving to avoid crashing into walls",
            "Last as long as possible to earn a higher score",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Watch the patterns  obstacles give small hints before moving",
            "Stay centered to react faster from either direction",
            "Don’t panic when the speed rises  controlled quick moves work best",
            "Practice makes your reflexes sharper every run",
          ],
        },
      ],
      features: [
        {
          title: "1. Fast, Fun & Easy to Jump Into",
          content:
            "Short rounds, smooth controls, and fresh obstacle challenges keep the excitement going with every attempt.",
        },
        {
          title: "2. Replay Again & Again",
          content:
            "Perfect for quick breaks or competitive score chasing. Each playthrough feels new as obstacles shift and speed changes.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers focus on clean visuals and responsive movement so every dodge feels precise and satisfying.",
        },
      ],
    },
  },
  {
    id: "SuperRun",
    name: "Super Run",
    img: supermario,
    banner: require("../Assets/images/banner/super_run.jpg"),
    description: "Jump, run & save the kingdom!",
    gamePath: "/Games/virtual_voyage/index.html",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Super Run Online Free",
      sections: [
        {
          title: "1. What is Super Run?",
          content:
            "Super Run is a fun platform adventure where you dash through exciting levels, jump over tricky obstacles, and collect items along the way. Each stage brings new challenges and hidden paths  perfect for players who love exploration and quick action.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Super Mario, players explore colorful stages, discover hidden secrets, and customize their avatars to reflect their style. The game combines classic platforming action with modern quests and storytelling, offering a fresh twist on a beloved adventure.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Run through different worlds and overcome increasing challenges as you progress. From moving platforms to sneaky enemies, quick thinking and precise jumps are the key to success. With each level, the excitement  and fun  keep rising.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Super Run",
          content:
            "Stay on your toes as you run through colorful environments full of surprises. Time your jumps, avoid enemies, and make it to the finish line while grabbing as many rewards as possible.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Use arrow keys or touch controls to run and jump",
            "Avoid falling into gaps or hitting obstacles",
            "Collect coins and power ups to boost your score",
            "Reach the end of each level to unlock the next adventure",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Look out for secret blocks and hidden paths  they often contain bonus items",
            "Keep moving, but slow down when you spot a danger ahead",
            "Learn enemy patterns to pass them safely",
            "Coins help increase your score, so collect as many as you can",
          ],
        },
      ],
      features: [
        {
          title: "1. Classic Running Fun with a Fresh Style",
          content:
            "Bright visuals, smooth controls, and rewarding challenges make every run enjoyable for players of all ages.",
        },
        {
          title: "2. Built for Adventure Lovers",
          content:
            "Jump, explore, and discover surprises in every level. Perfect for quick play sessions or longer gaming time.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our game design team focuses on creative level layouts and responsive movement so every jump feels just right and every stage feels fun to explore.",
        },
      ],
    },
  },

  {
    id: "MiniArmyFight",
    name: "Mini Army Fight",
    img: minimilitia,
    banner: require("../Assets/images/banner/mini_army_fight.jpg"),
    description: "Battle foes & defend your base!",
    gamePath: "/Games/cyber_sentinel/index.htm",
    category: "Action",
    type: "Trending",
    about: {
      heading: "Play Mini Army Fight Game Free",
      sections: [
        {
          title: "1. What is Mini Army Fight?",
          content:
            "Mini Army Fight is a fast-paced survival shooting game where you face waves of enemies and do everything you can to stay alive. Move smart, react quickly, and take down threats before they overwhelm you. Every second counts on the battlefield.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Mini Militia Game, players battle waves of enemies, dodge incoming fire, and counterattack to clear the field. The game features fast-paced shooting mechanics, power-ups, and a focus on quick defensive tactics.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Battle through waves of relentless opponents with fast and responsive shooting mechanics. As the challenge increases, only smart strategy and quick reflexes will keep you alive. Every play feels intense and exciting  perfect for action lovers.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Mini Army Fight",
          content:
            "Gear up and jump into non stop combat. Use your skills to dodge bullets, collect helpful power ups, and defeat enemies coming from all sides. Survive longer, score higher, and keep the fight going.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Use controls to move around the battlefield",
            "Aim and shoot enemies before they attack",
            "Collect health and weapon upgrades for an advantage",
            "Try to survive as long as possible to increase your score",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Keep moving  standing still makes you an easy target",
            "Grab power ups whenever they appear, they boost your survival",
            "Watch enemy patterns to avoid getting trapped",
            "Focus on the most dangerous targets first",
          ],
        },
      ],
      features: [
        {
          title: "1.Intense Action With Simple Controls",
          content:
            "Quick to learn and easy to jump in  but surviving long is the real challenge.",
        },
        {
          title: "2. Endless Replayability",
          content:
            "Each run feels unique with different enemy movements and power up drops, keeping the game fun every time you play.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our development team focuses on clean visuals, smooth firing mechanics, and balanced gameplay  ensuring every battle feels fair, thrilling, and enjoyable.",
        },
      ],
    },
  },
  {
    id: "forzahorizon",
    name: "Forza Horizon 5",
    img: forzahorizon,
    banner: require("../Assets/images/banner/forza_horizon_5.jpg"),
    description: "Race wild & explore open roads!",
    gamePath: "/Games/rally_car_racing/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Forza Horizon 5 Online free",
      sections: [
        {
          title: "1. What is Forza Horizon 5?",
          content:
            "Forza Horizon 5 is an exhilarating open-world racing game featured by htmlh5games. Players drive through breathtaking landscapes, complete thrilling challenges, and race against competitors to become the ultimate racing champion.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Forza Horizon 5, players choose from a diverse lineup of cars, participate in time-limited races, and collect powerful boosts. The game combines stunning visuals with realistic driving physics, delivering an unforgettable racing adventure.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Forza Horizon 5, players choose from a diverse lineup of cars, participate in time-limited races, and collect powerful boosts. The game combines stunning visuals with realistic driving physics, delivering an unforgettable racing adventure.",
        },
      ],
      features: [
        {
          title: "1. Enter the Racing World with crzii games",
          content:
            "Feel the rush of high speed racing across scenic roads and dynamic weather conditions. Compete in exciting events, master sharp turns, and enjoy the freedom to explore an open world built for speed lovers!",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a dedicated team passionate about bringing top tier racing experiences to gamers everywhere. With Forza Horizon 5, we aim to offer players a blend of realistic driving, strategic racing, and breathtaking exploration.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our experienced developers and designers work tirelessly to recreate the thrill of racing. Through detailed car models, lifelike environments, and smooth controls, we craft immersive journeys that captivate racing enthusiasts worldwide.",
        },
      ],
    },
  },
  {
    id: "solitairs",
    name: "Solitaire",
    img: solitairs,
    banner: require("../Assets/images/banner/solitaire.jpg"),
    description: "Stack cards & clear the board!",
    gamePath: "/Games/solitaire_classic/game.htm",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Enjoy Solitaire game free",
      sections: [
        {
          title: "1. What is Solitaire?",
          content:
            "Solitaire is the timeless single-player card game now brought to life on htmlh5games! Perfect for relaxing moments, quick mental refreshers, or daily brain training, it’s the classic you know and love—beautifully designed and smooth to play.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Play the classic Klondike Solitaire: stack cards in alternating colors, organize them in descending order, and move all cards to the foundation piles by suit. Simple to pick up, endlessly satisfying to master!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Play the classic Klondike Solitaire: stack cards in alternating colors, organize them in descending order, and move all cards to the foundation piles by suit. Simple to pick up, endlessly satisfying to master!",
        },
      ],
      features: [
        {
          title: "1. Classic Fun Anytime",
          content:
            "Enjoy the familiar gameplay that millions love, with the freedom to start, pause, and continue your game whenever you like.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring classic games to modern screens with style and comfort. Solitaire keeps the nostalgic charm alive while adding a polished, user-friendly experience.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team carefully crafted every card, shuffle, and animation to feel just right—whether you’re a first-time player or lifelong fan.",
        },
      ],
    },
  },
  {
    id: "templerun",
    name: "Temple Run 2",
    img: templerun,
    banner: require("../Assets/images/banner/temple_run_2.jpg"),
    description: "Run fast & escape the temple!",
    gamePath: "/Games/subway_footrace/index.html",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Temple Run 2 Game Free Online",
      sections: [
        {
          title: "1. What is Temple Run 2?",
          content:
            "Temple Run 2 is a fast and exciting endless runner where you race through busy streets, dodge dangerous obstacles, and try to stay alive as long as you can. Run nonstop, grab coins, and unlock boosts that help you reach new high scores.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Use quick swipes to jump over barriers, dodge speeding cars, and slide under roadblocks. Watch out for bombs scattered along the way — one wrong move could end your run. Keep your reflexes sharp, collect as many coins and power-ups as you can, and aim for the longest run possible!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Each run feels different. The road changes, the speed rises, and challenges keep increasing. Coins help unlock new upgrades and make future runs even more fun. The longer you survive, the bigger your score and rewards.",
        },
      ],

      extraContent: [
        {
          title: "🎮 Game: Temple Run 2",
          content:
            "Swipe to turn, jump, or slide while the speed keeps increasing. Cars, barriers, and traps appear suddenly  your quick reflexes decide whether the run continues or ends Collect special power ups and enjoy the thrill of chasing your best record.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Swipe left or right to change lanes",
            "Swipe up to jump over obstacles",
            "Swipe down to slide under barriers",
            "Collect coins and stay focused to survive longer",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Stay in the center lane to react faster",
            "Grab shields and speed boosts whenever possible",
            "Watch the road ahead  obstacles appear quickly",
            "Practice timing jumps to avoid sudden crashes",
          ],
        },
      ],
      features: [
        {
          title: "1. Endless Running Action",
          content:
            "Simple controls with fast gameplay that keeps players on their toes  every second counts.",
        },
        {
          title: "2. Fun for Everyone",
          content:
            "Easy to learn, exciting to master  perfect for quick entertainment and long high score sessions.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers designed smooth movement, colorful roads, and challenging obstacle layouts to make every run thrilling.",
        },
      ],
    },
  },
  // {
  //   id: "Wormate",
  //   name: "Wormate Game",
  //   img: warmate,
  //   banner: require("../Assets/images/banner/warmate_game.jpg"),
  //   description: "Slither, grow, and outlast everyone!",
  //   gamePath: "/Games/extraterrestrial_serpent/index.html",
  //   category: "Adventure",
  //   type: "Latest",
  //   about: {
  //     heading: "Online Snake Battle Free",
  //     sections: [
  //       {
  //         title: "1. What is Snake Battle?",
  //         content:
  //           "Snake Battle is a fun and competitive arena game where you guide a growing snake through a field full of food and other players. Your mission is simple  grow bigger, survive longer, and outsmart your opponents without crashing into them.",
  //       },
  //       // {
  //       //   title: "2. Gameplay",
  //       //   content:
  //       //     "In Wormate, players must navigate a shared arena filled with other worms. The goal is to grow by collecting food while avoiding collisions with other players. Strategic movement, quick reflexes, and clever traps are key to survival. As the worm grows longer, the challenge and the fun increases.",
  //       // },
  //     ],
  //     gameplay: [
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "The challenge rises as more snakes join the arena. Quick decisions and clever movements help you survive longer. Every second adds more excitement  grow as much as you can before someone cuts you off.",
  //       },
  //     ],
  //     extraContent: [
  //       {
  //         title: "🎮 Game: Snake Battle",
  //         content:
  //           "Collect tasty treats around the arena to become longer and stronger. Move carefully around bigger snakes and try to trick others into hitting you. Whether you like strategy or speed, every match brings a new chance to climb the leaderboard.",
  //       },
  //       {
  //         title: "❓ How to Play",
  //         list: [
  //           "Use mouse or touch controls to move your snake",
  //           "Collect items to grow in size",
  //           "Avoid running into other snakes",
  //           "Try to make opponents crash into you for bonus food",
  //         ],
  //       },
  //       {
  //         title: "💡 Tips",
  //         list: [
  //           "Stay on the edges when starting  fewer enemies to bump into",
  //           "Use speed boosts smartly to trap opponents",
  //           "The bigger you grow, the harder it is to turn  plan ahead",
  //           "Follow other snakes for easy food when they get eliminated",
  //         ],
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Grow and Outsmart",
  //         content:
  //           "Colorful visuals, smooth controls, and competitive battles create fast fun for all ages.",
  //       },
  //       {
  //         title: "2. Always a New Challenge",
  //         content:
  //           "Multiplayer style gameplay means every match is different  new strategies, new rivals, new surprises.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "Our game team focuses on responsive motion, bright graphics, and lag free action so gameplay always feels exciting and fair.",
  //       },
  //     ],
  //   },
  // },
   {
    id: "wormate",
    name: "Wormate Game",
    img: warmate,
    banner: require("../Assets/images/banner/warmate_game.jpg"),
    description: "Slither, grow, and outlast everyone!",
    gamePath: "/Games/extraterrestrial_serpent/index.html",
    category: "Adventure",
    type:"Latest",
    about: {
      heading: "Online Wormate Game Free",
      sections: [
        {
          title: "1. What is Wormate?",
          content:
            "Wormate is a colorful and fast paced multiplayer worm game featured on htmlh5games. Inspired by classic snake mechanics, players control growing worms in a vibrant arena, competing to become the biggest worm by consuming sweets, cakes, and power ups.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Wormate, players must navigate a shared arena filled with other worms. The goal is to grow by collecting food while avoiding collisions with other players. Strategic movement, quick reflexes, and clever traps are key to survival. As the worm grows longer, the challenge and the fun increases.",
        // },
      ],
       gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Wormate, players must navigate a shared arena filled with other worms. The goal is to grow by collecting food while avoiding collisions with other players. Strategic movement, quick reflexes, and clever traps are key to survival. As the worm grows longer, the challenge and the fun increases.",
        },
      ],
      features: [
        {
          title: "1. Grow and Conquer",
          content:
            "Wormate offers addictive gameplay with bright visuals and smooth controls. The game features various skins, power ups, and competitive multiplayer action, making each match unique and full of surprises.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we’re passionate about creating engaging, accessible games for players of all ages. Wormate helps develop planning skills, quick reactions, and spatial awareness all while having tons of fun in a safe and colorful virtual world.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "The creative minds at htmlh5games have optimized Wormate for fun and performance. With eye catching graphics, easy controls, and exciting progression, we ensure a smooth and exciting gaming experience whether you're a first time player or a seasoned worm warrior.",
        },
      ],
    },
  },

  // {
  //   id: "angrybirds",
  //   name: "Angry Birds",
  //   img: angrybirds,
  //   banner: require("../Assets/images/banner/angry_birds.jpg"),
  //   description: "Fling birds & topple the pigs!",
  //   gamePath: "/Games/wrathful_warriors/index.html",
  //   category: "Adventure",
  //   type: "Trending",
  //   bannerimg: bannerangry,
  //   shadowColor: "#e85c51",
  //   shadowpx: "-8px 8px",
  //   playbutton: redplay,
  //   buttonsize: "62px",
  //   about: {
  //     heading: "Play Crazy Birds Attack Online Free",
  //     sections: [
  //       {
  //         title: "1. What is Crazy Birds Attack?",
  //         content:
  //           "Crazy Birds Attack is a fun slingshot challenge where you launch birds to crush tricky targets and complete exciting missions. Aim carefully, use each bird’s power, and take down every structure standing in your way.",
  //       },
  //       // {
  //       //   title: "2. Gameplay",
  //       //   content:
  //       //     "In Angry Birds, players use a slingshot to launch different birds each with special abilities into creative, physics based puzzles. Break through wood, stone, and glass to topple pig-built forts, clear each level, and earn stars. The better your aim and timing, the higher your score!",
  //       // },
  //     ],
  //     gameplay: [
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "Each bird has a unique strength  some fly fast, others explode or break tough barriers. You’ll need smart strategy and good timing to clear the trickiest levels. As you progress, the forts become stronger and more creative, making every victory satisfying.",
  //       },
  //     ],
  //      extraContent: [
  //       {
  //         title: "🎮 Game: Crazy Birds Attack",
  //         content:
  //           "Pull the slingshot, choose your angle, and let the birds fly Wooden blocks, glass towers, and moving platforms  every level brings a new challenge. The goal is simple: destroy all the enemies and score as high as possible.",
  //       },
  //       {
  //         title: "❓ How to Play",
  //         list: [
  //           "Drag and aim to launch your bird from the slingshot",
  //           "Use bird abilities to break through obstacles",
  //           "Knock down enemy structures to win each level",
  //           "Earn stars based on skillful shots and fewer attempts",
  //         ],
  //       },
  //       {
  //         title: "💡 Tips",
  //         list: [
  //           "Analyze the structure before shooting  find the weak spots",
  //           "Use special powers at the right moment for max impact",
  //           "Sometimes one strong hit is better than multiple small attacks",
  //           "Experiment with angles for perfect destruction and higher scores",
  //         ],
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Aim, Smash & Win",
  //         content:
  //           "Fun physics with exciting destruction effects keep every shot thrilling and rewarding.",
  //       },
  //       {
  //         title: "2. Designed for All Ages",
  //         content:
  //           "Simple to start, but mastering levels takes skill  great for both casual and competitive players.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "Our game team focuses on bright visuals, responsive slingshot movement, and smooth level transitions for enjoyable play from start to finish.",
  //       },
  //     ],
  //   },
  // },
  {
    id: "angrybirds",
    name: "Angry Birds",
    img: angrybirds,
    banner: require("../Assets/images/banner/angry_birds.jpg"),
    description: "Fling birds & topple the pigs!",
    gamePath: "/Games/wrathful_warriors/index.html",
    category: "Adventure",
    type:"Trending",
    bannerimg:bannerangry,
    shadowColor: "#e85c51",
    shadowpx:"-8px 8px",
    playbutton:redplay,
     buttonsize:"62px",
    about: {
      heading: "Play Angry Birds Online Free",
      sections: [
        {
          title: "1. What is Angry Birds?",
          content:
            "Angry Birds is the classic, wildly popular slingshot adventure featured on htmlh5games! Join a flock of hilarious birds on a mission to rescue their stolen eggs by launching themselves at mischievous green pigs hiding in wobbly structures.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Angry Birds, players use a slingshot to launch different birds each with special abilities into creative, physics based puzzles. Break through wood, stone, and glass to topple pig-built forts, clear each level, and earn stars. The better your aim and timing, the higher your score!",
        // },
      ],
       gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Angry Birds, players use a slingshot to launch different birds each with special abilities into creative, physics based puzzles. Break through wood, stone, and glass to topple pig-built forts, clear each level, and earn stars. The better your aim and timing, the higher your score!",
        },
      ],
      features: [
        {
          title: "1. Fun Physics & Strategy",
          content:
            "Every level combines timing, strategy, and satisfying destruction. Discover each bird’s unique power from speedy dives to explosive impacts and plan the perfect shot.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring legendary games that everyone can enjoy whether it’s your first time playing or you’re a returning fan. Angry Birds delivers humor, challenge, and addictive fun all in one.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team recreated the classic Angry Birds magic for smooth, colorful gameplay that keeps you aiming for that perfect three-star score, round after round.",
        },
      ],
    },
  },
  // {
  //   id: "Trainrunner",
  //   name: "Subway Surfers",
  //   img: subwaysurf,
  //   banner: require("../Assets/images/banner/subway_surfers.jpg"),
  //   description: "Dash, dodge, and surf the subways!",
  //   gamePath: "/Games/tom_runner/index.htm",
  //   category: "Adventure",
  //   type: "Trending",
  //   bannerimg: bannersubway,
  //   shadowColor: "#65b8db",
  //   shadowpx: "-5px 5px",
  //   playbutton: buleplay,
  //   buttonsize: "52px",
  //   about: {
  //     heading: "Train Runner Online Free Game",
  //     sections: [
  //       {
  //         title: "1. What is Train Runner ?",
  //         content:
  //           "Train Runner is an exciting endless running game where you sprint through busy railway tracks, dodge fast moving trains, and grab as many coins as you can. Quick reflexes and fast decisions are the key to staying ahead and running farther than ever.",
  //       },
  //       // {
  //       //   title: "2. Gameplay",
  //       //   content:
  //       //     "In 'Subway Surfers', you play as a young graffiti artist who’s caught in the act. The chase begins through subway tracks full of moving trains, barriers, and surprises. With power-ups like hoverboards, jetpacks, and magnets, the game challenges you to run farther, faster, and smarter.",
  //       // },
  //     ],
  //     gameplay: [
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "Each run is unpredictable with constantly changing obstacles and train patterns. The game keeps getting faster, increasing the fun and challenge. Aim to beat your high score and enjoy the thrill of never ending action.",
  //       },
  //     ],
  //      extraContent: [
  //       {
  //         title: "🎮 Game: Train Runner",
  //         content:
  //           "The chase begins Speed through tracks, leap over roadblocks, slide under signs, and switch lanes to escape danger. Collect power ups like jetpacks and hoverboards to help you travel greater distances while boosting your score.",
  //       },
  //       {
  //         title: "❓ How to Play",
  //         list: [
  //           "Swipe left or right to change lanes",
  //           "Swipe up to jump and down to slide",
  //           "Collect coins and special boosts",
  //           "Keep running  crashing ends the game",
  //         ],
  //       },
  //       {
  //         title: "💡 Tips",
  //         list: [
  //           "Use hoverboards during tough sections to stay safe",
  //           "Look ahead to plan your next move early",
  //           "Magnets help collect coins without aiming",
  //           "Daily tasks help unlock rewards faster",
  //         ],
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Run, Dodge & Collect",
  //         content:
  //           "Smooth animations, colorful environments, and fun mechanics make every run exciting for players of all ages.",
  //       },
  //       {
  //         title: "2. Thrilling Endless Adventure",
  //         content:
  //           "Missions, surprises, and powerful boosts keep the gameplay fresh every time you play.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "Our game team prioritizes fast controls, polished graphics, and a fun experience so you can enjoy uninterrupted endless running.",
  //       },
  //     ],
  //   },
  // },
   {
    id: "subwaysurf",
    name: "Subway Surfers",
    img: subwaysurf,
    banner: require("../Assets/images/banner/subway_surfers.jpg"),
    description: "Dash, dodge, and surf the subways!",
    gamePath: "/Games/tom_runner/index.htm",
    category: "Adventure",
    type:"Trending",
    bannerimg:bannersubway,
     shadowColor: "#65b8db",
     shadowpx:"-5px 5px",
     playbutton:buleplay,
       buttonsize:"52px",
    about: {
      heading: "Subway Surfers Online Free Game",
      sections: [
        {
          title: "1. What is Subway Surfers ?",
          content:
            "Subway Surfers is one of the most iconic endless runner games,on htmlh5games. In this fast paced adventure, players dash through subways, dodge trains, and collect coins as they try to escape from the inspector and his dog.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In 'Subway Surfers', you play as a young graffiti artist who’s caught in the act. The chase begins through subway tracks full of moving trains, barriers, and surprises. With power-ups like hoverboards, jetpacks, and magnets, the game challenges you to run farther, faster, and smarter.",
        // },
      ],
       gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Subway Surfers, you play as a young graffiti artist who’s caught in the act. The chase begins through subway tracks full of moving trains, barriers, and surprises. With power ups like hoverboards, jetpacks, and magnets, the game challenges you to run farther, faster, and smarter.",
        },
      ],
      features: [
        {
          title: "1. Dash, Dodge, and Collect",
          content:
            "Subway Surfers delivers visually stunning gameplay with smooth animations and vibrant cityscapes. Each run is unique, offering thrilling experiences filled with missions, daily challenges, and character unlocks.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we believe in delivering games that are not just fun but also engaging for players of all ages. Subway Surfers boosts reflexes, focus, and hand eye coordination, wrapped in a colorful, fast paced environment.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team at htmlh5games brings globally popular titles like Subway Surfers to your screen, optimized for smooth performance and endless fun. We aim to provide high quality, family friendly games that keep you coming back for more.",
        },
      ],
    },
  },
  {
    id: "ninjaslice",
    name: "Ninja Fruit Slice",
    img: ninjaslice,
    banner: require("../Assets/images/banner/ninja_slice.jpg"),
    description: "Slice fast, score big, be the ninja!",
    gamePath: "/Games/ninja_slice/index.html",
    category: "Action",
    type: "Trending",
    bannerimg: bannerfruit,
    shadowColor: "#9dbf54",
    shadowpx: "-5px 5px",
    playbutton: greenplay,
    buttonsize: "52px",
    about: {
      heading: "Play Free Ninja Fruit Slice Online",
      sections: [
        {
          title: "1. What is Ninja Fruit Slice?",
          content:
            "Ninja Fruit Slice is a fast-paced, action-packed slicing game available on htmlh5games. Step into the shoes of a skilled ninja and slice flying fruits with precision and speed—just be careful to avoid the bombs!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Ninja Fruit Slice, fruits fly across the screen and your mission is to slice as many as possible before they fall. Swipe fast to chop through watermelon, apples, bananas, and more. But beware hidden bombs can end your game instantly! The more combos you slice, the higher your score.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Ninja Fruit Slice, fruits fly across the screen and your mission is to slice as many as possible before they fall. Swipe fast to chop through watermelon, apples, bananas, and more. But beware hidden bombs can end your game instantly! The more combos you slice, the higher your score.",
        },
      ],
      features: [
        {
          title: "1. Slice, Swipe, and Score",
          content:
            "With smooth controls and satisfying slicing effects, Ninja Fruit Slice offers endless fun and a real test of reflexes. Great for short bursts of gameplay or high-score chases, it's addictive, colorful, and full of juicy action.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring dynamic and skill based games to life. Ninja Fruit Slice helps players sharpen hand-eye coordination, reaction speed, and focus all while having tons of fun in a ninja-style setting.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our dedicated team at htmlh5games has designed Ninja Fruit Slice to be visually exciting, fast-loading, and highly responsive. Whether you’re a casual gamer or a ninja-in-training, this game promises excitement with every slice.",
        },
      ],
    },
  },
  {
    id: "Warduty",
    name: "War Duty",
    img: callofduty,
    banner: require("../Assets/images/banner/war_duty.jpg"),
    description: "Lock, load & lead your squad!",
    gamePath: "/Games/guardian_battalion/index.html",
    category: "Action",
    type: "Trending",
    about: {
      heading: "Play War Duty Online Free ",
      sections: [
        {
          title: "1. What is War Duty ?",
          content:
            "War Duty is a thrilling first person shooting game where you step into the role of a trained soldier on dangerous missions. Every battle tests your aim, strategy, and reaction speed as you take down enemies and defend your team on the front lines.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Master a wide range of weapons, gear, and tactics as you fight through explosive campaigns and challenge players worldwide. From close-quarters firefights to long-range sniper duels, every moment demands precision, strategy, and courage under fire.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "War Duty combines fast reaction combat with smart tactical decisions. Each mission brings new challenges  enemy soldiers, explosive traps, and unexpected attacks. With sharper aim and better strategy, you can rise to become the ultimate warrior.",
        },
      ],
       extraContent: [
        {
          title: "🎮 Game: War Duty",
          content:
            "Engage in realistic combat environments filled with intense firefights. Switch between different weapons, take cover, and eliminate threats before they take you down. Whether you're advancing through missions or battling tough opponents, every moment brings high energy action.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Use on screen controls to move, aim, and shoot",
            "Switch weapons strategically depending on the situation",
            "Stay behind cover to avoid taking heavy damage",
            "Complete objectives to progress and earn rewards",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Aim for headshots to defeat enemies faster",
            "Keep moving  standing still makes you an easy target",
            "Reload during safe moments to stay prepared",
            "Use grenades and special gear to handle groups of enemies",
          ],
        },
      ],
      features: [
        {
          title: "1. Tactical Shooting Action",
          content:
            "Smooth controls, thrilling sound effects, and dynamic battles create a realistic war experience for fans of action games.",
        },
        {
          title: "2. Missions & Modes",
          content:
            "Play through intense missions or test your shooting skills in competitive challenges  always fresh, always exciting.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team focuses on polished graphics and responsive gameplay to keep every battle engaging and enjoyable.",
        },
      ],
    },
  },
  {
    id: "cokkingfever",
    name: "Cooking Fever",
    img: cokkingfever,
    banner: require("../Assets/images/banner/cooking_fever.jpg"),
    description: "Cook dishes & serve hungry customers!",
    gamePath: "/Games/kids_cooking_game/index.html",
    category: "Kids",
    type: "Trending",
    about: {
      heading: "Cooking Fever Online Game",
      sections: [
        {
          title: "1. What is Cooking Fever?",
          content:
            "Cooking Fever is a fast-paced time management cooking game developed by htmlh5games. Players prepare delicious meals and desserts from around the world, improving multitasking skills, speed, and creativity.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Cooking Fever, players cook and serve dishes to demanding customers across various themed restaurants. The game features colorful graphics, a wide variety of recipes, and exciting kitchen upgrades to keep the gameplay fresh and challenging.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Cooking Fever, players cook and serve dishes to demanding customers across various themed restaurants. The game features colorful graphics, a wide variety of recipes, and exciting kitchen upgrades to keep the gameplay fresh and challenging.",
        },
      ],
      features: [
        {
          title: "1. Step into the Culinary World with htmlh5games",
          content:
            "Experience the excitement of running your own kitchen! Cook, decorate, and delight customers as you master countless recipes and restaurant themes.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team dedicated to making fun and engaging simulation games. With 'Cooking Fever', we bring the joy of cooking and restaurant management to players everywhere.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented team crafts games that combine vibrant visuals with addictive gameplay. Their passion ensures 'Cooking Fever' stays entertaining, rewarding, and loved by foodies and gamers alike.",
        },
      ],
    },
  },

  {
    id: "knifehit",
    name: "Knife Hit",
    img: knifehit,
    banner: require("../Assets/images/banner/knife_hit.jpg"),
    description: "Throw knives & shatter targets!",
    gamePath: "/Games/knife_cutter/knif_hit.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Knife Hit Online Free Game",
      sections: [
        {
          title: "1. What is Knife Hit?",
          content:
            "Knife Hit is a fast-paced arcade game on htmlh5games, where your challenge is simple yet addictive: throw knives to hit spinning logs and break them apart without hitting other knives already stuck!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap to launch your knives at just the right moment. As the log spins faster or changes direction, perfect timing becomes your best weapon. Smash the target, unlock new knives, and face tougher bosses as your skills grow.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap to launch your knives at just the right moment. As the log spins faster or changes direction, perfect timing becomes your best weapon. Smash the target, unlock new knives, and face tougher bosses as your skills grow.",
        },
      ],
      features: [
        {
          title: "1. Simple, Addictive Fun",
          content:
            "Easy one-tap control, but only sharp focus and precision will break every target. Earn and collect new knife designs to make each throw feel fresh and stylish. Logs change speed and direction, keeping every level unpredictable and exciting.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love transforming quick reflex games into truly satisfying challenges. Knife Hit is about timing, rhythm, and the thrill of a perfect throw.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers crafted smooth knife-throw mechanics, clean visuals, and rewarding effects to keep you saying, “Just one more try!”",
        },
      ],
    },
  },
  {
    id: "hillclimb",
    name: "Hill Climb Racing 2",
    img: hillclimb,
    banner: require("../Assets/images/banner/hill_climb_racing_2.jpg"),
    description: "Climb hills & race to victory!",
    gamePath: "/Games/thrill_seeker_racers/index.html",
    category: "Racing",
    type: "Trending",
    about: {
      heading: "Play Hill Climb Racing 2 Online Free",
      sections: [
        {
          title: "1. What is Hill Climb Racing 2?",
          content:
            "Hill Climb Racing 2 is an action-packed racing adventure on htmlh5games, where driving skill and daring stunts help you conquer hills, earn points, and unlock awesome new cars! Race against competitor cars and prove who rules the road.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Start your journey with a trusty beginner car, then climb hills, perform flips, and master tricky tracks to collect points. Use those points to unlock stronger, faster, and cooler cars! Each new car helps you tackle tougher hills and beat rival drivers waiting to challenge you on your climb to the top.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Start your journey with a trusty beginner car, then climb hills, perform flips, and master tricky tracks to collect points. Use those points to unlock stronger, faster, and cooler cars! Each new car helps you tackle tougher hills and beat rival drivers waiting to challenge you on your climb to the top.",
        },
      ],
      features: [
        {
          title: "1. Unlock & Compete",
          content:
            "Earn points to unlock new cars and upgrade them. Face off against competitor cars on varied and challenging tracks, from rocky mountains to snowy slopes. With bouncy physics, thrilling jumps, and loop-the-loops, every race feels different. Perform flips and tricks to boost your score and keep the action going.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring racing games to life with unique challenges and endless fun. Hill Climb Racing 2 blends racing, stunts, and strategy so anyone can enjoy racing at their own pace.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team crafted every track, car, and jump to keep players coming back for “one more race.” From bright visuals to smooth gameplay, we ensure your hill climb adventure is always thrilling.",
        },
      ],
    },
  },

  {
    id: "monster",
    name: "Monster Jam Steel Titans 2",
    img: monster,
    banner: require("../Assets/images/banner/monster_jam_steel_titans_2.jpg"),
    description: "Smash, race & conquer the arena!",
    gamePath: "/Games/monster_truck/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Monster Jam Steel Titans 2 Play Online",
      sections: [
        {
          title: "1. What is Monster Jam Steel Titans 2?",
          content:
            "Monster Jam Steel Titans 2 is the ultimate monster truck experience on htmlh5games! Get behind the wheel of legendary Monster Jam trucks and unleash power, stunts, and destruction like never before! It's all about big air, big wheels, and even bigger action!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Choose your favorite monster truck and race across wild tracks, stunt arenas, and off-road worlds. Perform insane tricks like backflips, donuts, and crush cars in your path! Compete in racing events or freestyle challenges and unlock new trucks, upgrades, and stunt combos.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Choose your favorite monster truck and race across wild tracks, stunt arenas, and off-road worlds. Perform insane tricks like backflips, donuts, and crush cars in your path! Compete in racing events or freestyle challenges and unlock new trucks, upgrades, and stunt combos.",
        },
      ],
      features: [
        {
          title: "1. Epic Monster Trucks",
          content:
            "Drive famous Monster Jam trucks like Grave Digger, Max-D, El Toro Loco, and more! Each truck is designed with realistic physics, roaring engines, and customizable paint jobs. Explore five new massive worlds filled with hidden secrets, obstacles, ramps, and challenges. From stadiums to off-road environments, experience the full thrill of monster truck mayhem.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring adrenaline-filled experiences to your screen. Monster Jam Steel Titans 2 is crafted for fans of speed, power, and outrageous stunts.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers craft realistic trucks, detailed arenas, and smooth gameplay. Their dedication ensures 'Monster Jam Steel Titans 2' feels explosive, authentic, and endlessly entertaining.",
        },
      ],
    },
  },
  {
    id: "assetto",
    name: "Assetto Corsa",
    img: assetto,
    banner: require("../Assets/images/banner/assetto_corsa.jpg"),
    description: "Drive fast & master realistic tracks!",
    gamePath: "/Games/revenge_road_rush/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Free Assetto Corsa Game",
      sections: [
        {
          title: "1. What is Assetto Corsa?",
          content:
            "Assetto Corsa is the ultimate driving simulator on htmlh5games, crafted for racing enthusiasts who crave authentic, precision-based racing. With stunning real-world tracks, meticulously detailed cars, and lifelike physics, it’s more than just a game it’s a true racing experience.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Choose from a garage of legendary sports cars and professional racing machines. Master famous circuits like Monza, Silverstone, and Nürburgring, each recreated with laser-scanned accuracy. Feel every turn, brake, and acceleration thanks to advanced driving physics that make every lap unique and rewarding.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Choose from a garage of legendary sports cars and professional racing machines. Master famous circuits like Monza, Silverstone, and Nürburgring, each recreated with laser-scanned accuracy. Feel every turn, brake, and acceleration thanks to advanced driving physics that make every lap unique and rewarding.",
        },
      ],
      features: [
        {
          title: "1. True-to-Life Racing",
          content:
            "Incredible attention to detail, realistic car handling, and authentic engine sounds bring you closer than ever to real motorsport.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring world-class racing simulations to your fingertips. Assetto Corsa is perfect for drivers who love realism, strategy, and the pure thrill of racing.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Built by passionate racing fans, every track curve, tire slip, and engine roar in Assetto Corsa has been carefully crafted to deliver an authentic and unforgettable experience.",
        },
      ],
    },
  },
  {
    id: "counterstrike",
    name: "Counter Strike 2",
    img: counterstrike,
    banner: require("../Assets/images/banner/counter_strike_2.jpg"),
    description: " Aim, shoot & outsmart opponents!",
    gamePath: "/Games/tactical_strike/index.html",
    category: "Action",
    type: "Trending",
    about: {
      heading: "Counter Strike 2 Online Free Game",
      sections: [
        {
          title: "1. What is Counter Strike 2?",
          content:
            "Counter Strike 2 is an action shooting game developed by htmlh5games. Players take control of a soldier who must shoot and eliminate enemies from his fixed firing line, collecting coins after each successful takedown.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Counter Strike 2, players aim and fire to defeat waves of enemies, earning coins to unlock upgrades and power-ups. Quick reflexes and sharp accuracy are key to surviving longer and climbing the leaderboard.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Counter Strike 2, players aim and fire to defeat waves of enemies, earning coins to unlock upgrades and power-ups. Quick reflexes and sharp accuracy are key to surviving longer and climbing the leaderboard.",
        },
      ],
      features: [
        {
          title: "1. Step into the Action with htmlh5games",
          content:
            "Experience intense shooting gameplay where every shot counts! Eliminate enemies, collect coins, and enjoy the thrill of becoming a top shooter.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about making action-packed shooting games. With Counter Strike 2, we deliver fast-paced gameplay that challenges players’ aim, timing, and focus.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers work hard to bring dynamic visuals and satisfying shooting mechanics to life. Their dedication ensures Counter Strike 2 is exciting, rewarding, and fun for every player.",
        },
      ],
    },
  },
  {
    id: "madalincars",
    name: "Madalin Cars",
    img: madalincars,
    banner: require("../Assets/images/banner/madalin_cars.jpg"),
    description: "Race, drift, and rule the road!",
    gamePath: "/Games/racing_ramp/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Madalin Cars Online",
      sections: [
        {
          title: "1. What is Madalin Cars?",
          content:
            "Madalin Cars is a high-speed 3D car simulation game featured on htmlh5games. Known for its realistic driving physics and expansive open-world maps, this game lets players explore, race, and perform jaw-dropping stunts in powerful sports cars.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Madalin Cars, players choose from a wide selection of exotic cars and hit the roads for thrilling solo drives or multiplayer fun. From drifting around sharp turns to launching off ramps, the game offers a sandbox-style experience where creativity meets speed and control.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Madalin Cars, players choose from a wide selection of exotic cars and hit the roads for thrilling solo drives or multiplayer fun. From drifting around sharp turns to launching off ramps, the game offers a sandbox-style experience where creativity meets speed and control.",
        },
      ],
      features: [
        {
          title: "1. Drive, Drift, and Explore",
          content:
            "Madalin Cars provides a dynamic driving experience with detailed environments, realistic car models, and seamless controls. Whether you prefer free roaming or racing against others, there's something for every car lover",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we’re passionate about delivering immersive and educational gaming experiences. Madalin Cars enhances spatial awareness, driving reflexes, and logical thinking while offering endless fun and freedom behind the wheel.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our expert team at htmlh5games ensures every game is optimized for fun and quality. With rich visuals, customizable settings, and intuitive mechanics, Madalin Cars is crafted to give players of all ages the thrill of virtual driving in a safe and engaging environment.",
        },
      ],
    },
  },
  {
    id: "basketblitz",
    name: "Basket Blitz",
    img: basketblitz,
    banner: require("../Assets/images/banner/basket_blitz.jpg"),
    description: "Dunk fast & score big points!",
    gamePath: "/Games/bounce_hoop/index.html",
    category: "Sports",
    type: "Featured",
    about: {
      heading: "Basket Blitz Online Free Game",
      sections: [
        {
          title: "1. What is Basket Blitz?",
          content:
            "Basket Blitz is a fast-paced basketball shooting game on htmlh5games, where it’s all about quick shots, perfect timing, and scoring as many baskets as you can before the clock runs out!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swipe or tap to launch your shots into the hoop. The basket might move, the timer keeps ticking, and every second counts. Score combos for extra points, unlock new basketball designs, and push your reflexes to the limit to climb the leaderboard.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Swipe or tap to launch your shots into the hoop. The basket might move, the timer keeps ticking, and every second counts. Score combos for extra points, unlock new basketball designs, and push your reflexes to the limit to climb the leaderboard.",
        },
      ],
      features: [
        {
          title: "1. Quick & Addictive Play",
          content:
            "Easy to start just swipe to shoot but keeping the streak going takes focus and speed.Hit perfect shots in a row to earn massive combo points and beat your record.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love arcade games that mix skill, reflexes, and excitement. Basket Blitz is designed for those moments when you want to jump in and shoot for the top.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers and artists crafted smooth shooting mechanics, lively visuals, and a fast rhythm that keeps you playing just one more round.",
        },
      ],
    },
  },
  {
    id: "motox3",
    name: "Moto X3M",
    img: motox3,
    banner: require("../Assets/images/banner/moto_x3m.jpg"),
    description: " Race bikes & beat wild stunts!",
    gamePath: "/Games/cycle_dash/index.html",
    category: "Racing",
    type: "Trending",
    about: {
      heading: "Play Free Moto X3M Game ",
      sections: [
        {
          title: "1. What is Moto X3M?",
          content:
            "Moto X3M is an adrenaline-charged motocross stunt game on htmlh5games, where you race against time, leap over deadly traps, and flip through explosive obstacle courses. Every level is packed with sharp turns, moving saws, and impossible jumps that put your bike skills to the test.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Hop on your dirt bike and speed through twisting tracks filled with ramps, loops, and crazy stunts. Perform backflips and front flips to save precious seconds but watch out! One wrong move can send you crashing down. Beat the clock to unlock new levels and prove you’re the ultimate stunt rider.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Hop on your dirt bike and speed through twisting tracks filled with ramps, loops, and crazy stunts. Perform backflips and front flips to save precious seconds but watch out! One wrong move can send you crashing down. Beat the clock to unlock new levels and prove you’re the ultimate stunt rider.",
        },
      ],
      features: [
        {
          title: "1. Extreme Stunt Action",
          content:
            "Easy controls make it simple to start, but only skill and practice will help you master every flip, jump, and landing. Ride through dozens of uniquely designed levels with fiery explosions, swinging hammers, spikes, and gravity-defying ramps.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring thrilling arcade fun to your screen. Moto X3M combines fast-paced racing with challenging stunts that keep players coming back for just one more try.”",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted every track and obstacle to challenge your reflexes, reward perfect timing, and deliver non-stop excitement.",
        },
      ],
    },
  },
  {
    id: "stickarcher",
    name: "Stickman Archer",
    img: stickarcher,
    banner: require("../Assets/images/banner/stickman_archer.jpg"),
    description: "Aim true and outshoot your rivals!",
    gamePath: "/Games/silent_strike/index.htm",
    category: "Action",
    type: "Trending",
    about: {
      heading: "Stickman Archer Online Free Game",
      sections: [
        {
          title: "1. What is Stickman Archer?",
          content:
            "Stickman Arche is an intense and addictive archery game featured on htmlh5games. Step into the shoes of a fearless stickman archer and test your aim in quick, skill based battles where precision is everything.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Stickman Archer, players take part in thrilling one-on-one duels where they must shoot arrows at their opponent before getting hit themselves. The game gets more challenging with moving targets, limited time, and dynamic angles, demanding quick thinking and steady hands.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Stickman Archer, players take part in thrilling one-on-one duels where they must shoot arrows at their opponent before getting hit themselves. The game gets more challenging with moving targets, limited time, and dynamic angles, demanding quick thinking and steady hands.",
        },
      ],
      features: [
        {
          title: "1. Aim, Fire, and Dominate",
          content:
            "Stickman Archer delivers exciting stick-figure action with simple controls and challenging mechanics. Players can engage in endless mode, survival mode, or quick duels—perfect for short bursts of fun or longer sessions of skill-building.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we aim to blend fun with focus. Stickman Archer encourages hand-eye coordination, strategic aiming, and fast reflexes. Whether you're a casual gamer or a competitive challenger, this game offers endless archery excitement.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our dedicated team at htmlh5games has crafted Stickman Archer to be fast, fun, and rewarding. With minimal design and maximum engagement, we focus on creating lightweight games that are high on skill and replay value perfect for players of all ages.",
        },
      ],
    },
  },
  {
    id: "bikeblitz",
    name: "Bike Blitz Game",
    img: bikeblitz,
    banner: require("../Assets/images/banner/bike_blitz_game.jpg"),
    description: "Race bikes & pull off stunts!",
    gamePath: "/Games/bike_blitz_bonanza/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Basket Blitz Free Online",
      sections: [
        {
          title: "1. What is Basket Blitz?",
          content:
            "Basket Blitz is a fast-paced basketball shooting game on htmlh5games, where it’s all about quick shots, perfect timing, and scoring as many baskets as you can before the clock runs out!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swipe or tap to launch your shots into the hoop. The basket might move, the timer keeps ticking, and every second counts. Score combos for extra points, unlock new basketball designs, and push your reflexes to the limit to climb the leaderboard.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Swipe or tap to launch your shots into the hoop. The basket might move, the timer keeps ticking, and every second counts. Score combos for extra points, unlock new basketball designs, and push your reflexes to the limit to climb the leaderboard.",
        },
      ],
      features: [
        {
          title: "1. Quick & Addictive Play",
          content:
            "Easy to start just swipe to shoot but keeping the streak going takes focus and speed.Hit perfect shots in a row to earn massive combo points and beat your record.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love arcade games that mix skill, reflexes, and excitement. Basket Blitz is designed for those moments when you want to jump in and shoot for the top.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers and artists crafted smooth shooting mechanics, lively visuals, and a fast rhythm that keeps you playing just one more round.",
        },
      ],
    },
  },
  {
    id: "christmaspreparation",
    name: "Christmas Preparation",
    img: christmaspreparation,
    banner: require("../Assets/images/banner/christmas_preparation.jpg"),
    description: " Style & prepare for Christmas fun!",
    gamePath: "/Games/christmas_preparation/index.html",
    category: "Kids",
    type: "Featured",
    about: {
      heading: "Christmas Preparation Online Game",
      sections: [
        {
          title: "1. What is Christmas Preparation?",
          content:
            "Christmas Preparation is a festive dress-up and makeover game developed by htmlh5games. Players help style the character with beautiful makeup, fashionable clothing, and sparkling accessories to get ready for the holiday celebrations.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Christmas Preparation, players choose from a wide range of dresses, hairstyles, and festive items to create the perfect holiday look. The game blends creativity and fashion, letting players design unique styles for Christmas parties and events.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Christmas Preparation, players choose from a wide range of dresses, hairstyles, and festive items to create the perfect holiday look. The game blends creativity and fashion, letting players design unique styles for Christmas parties and events.",
        },
      ],
      features: [
        {
          title: "1. Celebrate in Style with htmlh5games",
          content:
            "Step into the holiday spirit! Mix and match glamorous outfits, stunning makeup, and festive accessories to make your character shine this Christmas.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about designing fun and stylish dress-up games. With Christmas Preparation, we bring holiday magic and fashion together for a delightful experience.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented team creates charming visuals and easy-to-use styling tools. Their dedication ensures Christmas Preparation feels joyful, creative, and perfect for fashion lovers of all ages.",
        },
      ],
    },
  },

  {
    id: "archrymaster",
    name: "Archery Master 3D",
    img: archrymaster,
    banner: require("../Assets/images/banner/archery_master_3d.jpg"),
    description: " Aim, draw & hit the bullseye!",
    gamePath: "/Games/bullseye_challenge/index.html",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Archery Master 3D Online Free Game",
      sections: [
        {
          title: "1. What is Archery Master 3D?",
          content:
            "Archery Master 3D is a realistic and addictive archery simulation on htmlh5games, where your focus, aim, and timing decide every shot. Feel the thrill of drawing the bow, steadying your breath, and hitting the bullseye in stunning 3D environments.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Pull back your bow, aim carefully, and release your arrow towards moving or stationary targets. Compete across multiple levels with different wind conditions and distances that test your accuracy. Perfect your skills to unlock new bows, arrows, and challenging stages.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Pull back your bow, aim carefully, and release your arrow towards moving or stationary targets. Compete across multiple levels with different wind conditions and distances that test your accuracy. Perfect your skills to unlock new bows, arrows, and challenging stages.",
        },
      ],
      features: [
        {
          title: "1. Realistic Archery Action",
          content:
            "Smooth controls and lifelike physics recreate the feeling of real bow shooting.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring classic sports to life with modern graphics and intuitive gameplay. Archery Master 3D captures the calm focus and sharp skill of archery for everyone to enjoy.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted realistic arrow flight, subtle wind effects, and dynamic target challenges to make every shot feel rewarding.",
        },
      ],
    },
  },

  {
    id: "barbirgirl",
    name: "Barbie Girls Games",
    img: barbirgirl,
    banner: require("../Assets/images/banner/barbie_girls_games.jpg"),
    description: " Dress up & explore Barbie adventures!",
    gamePath: "/Games/taylors_party_parade/index.html",
    category: "Kids",
    type: "Latest",
    about: {
      heading: "Play Barbie Girls Game Online Free ",
      sections: [
        {
          title: "1. What is Barbie Girls Game?",
          content:
            "Barbie Girls Game is a sweet and magical dress-up and celebration game available on htmlh5games. It’s a baby girl’s special birthday, and you’re invited to help her prepare for the big day from baking her birthday cake to dressing her up in the perfect party outfit!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "The game begins with a fun baking session where you create a delicious birthday cake. Once the cake is ready, it's time to help the birthday girl get dressed! Choose from beautiful dresses, sparkling shoes, stylish purses, and accessories to make her shine. After she’s ready, her friends arrive, and the celebration begins with laughter, dancing, cake cutting, and unforgettable fun.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "The game begins with a fun baking session where you create a delicious birthday cake. Once the cake is ready, it's time to help the birthday girl get dressed! Choose from beautiful dresses, sparkling shoes, stylish purses, and accessories to make her shine. After she’s ready, her friends arrive, and the celebration begins with laughter, dancing, cake cutting, and unforgettable fun.",
        },
      ],
      features: [
        {
          title: "1. Celebrate in Style",
          content:
            "From baking to dressing to partying, Barbie Girls Game combines fun, fashion, and celebration in one heartwarming experience. Players can enjoy the joy of planning and enjoying a birthday party in a colorful and interactive way.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we believe in crafting stories that spark joy and creativity in every child. Barbie Girls Game helps kids develop a sense of planning, creativity, and emotional connection while enjoying a memorable celebration.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team at htmlh5games carefully designs every game to be safe, fun, and engaging. With lovely visuals, charming characters, and joyful music, Barbie Girls Game brings birthday magic to life for players of all ages.",
        },
      ],
    },
  },

  {
    id: "blockblast",
    name: "Block Blast",
    img: blockblast,
    banner: require("../Assets/images/banner/block_blast.jpg"),
    description: "Blast blocks & clear the screen!",
    gamePath: "/Games/gem_blocks_quest/index.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Block Blast Online Free Game",
      sections: [
        {
          title: "1. What is Block Blast?",
          content:
            "Block Blast is a thrilling, fast-paced arcade game on htmlh5games, where your goal isn’t to calmly match blocks it’s to smash, clear, and blast them away before the screen overflows! Quick thinking and faster reflexes will keep you alive as the blocks drop and the action speeds up.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Blocks drag from below in different shapes and patterns. Drop and blast them before the tower builds too high. Trigger chain reactions, collect special power-ups, and keep the board under control. The longer you survive, the faster and wilder the block rain becomes!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Blocks drag from below in different shapes and patterns. Drop and blast them before the tower builds too high. Trigger chain reactions, collect special power-ups, and keep the board under control. The longer you survive, the faster and wilder the block rain becomes!",
        },
      ],
      features: [
        {
          title: "1. Action-Packed Block Blasting",
          content:
            "No slow puzzle matching here just pure arcade action where speed and timing are everything.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning classic block mechanics into thrilling, modern arcade challenges. Block Blast is made for players who want energy, action, and quick gameplay.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed vibrant effects, smooth controls, and dynamic difficulty to keep each session intense and fun.",
        },
      ],
    },
  },

  {
    id: "bowling",
    name: "Bowling",
    img: bowling,
    banner: require("../Assets/images/banner/bowling.jpg"),
    description: "Roll strikes & top the lanes!",
    gamePath: "/Games/bowling_ball_brawl/index.html",
    category: "Sports",
    type: "Latest",
    about: {
      heading: "Play Bowling Game Online Free",
      sections: [
        {
          title: "1. What is Bowling?",
          content:
            "Bowling is a fun and classic sports game where you roll the ball down the lane and aim to knock down all ten pins Chase high scores, enjoy smooth throws, and feel the satisfaction of hitting that perfect strike.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swipe or tap to roll your ball down the lane, adjust your angle, and add just the right spin. Knock down as many pins as you can in each frame, rack up strikes and spares, and watch your score climb. Simple to pick up but truly rewarding to master!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Bowling offers smooth and relaxing play that gets more rewarding as your skill improves. Every strike feels great  every spare keeps the excitement going. It’s the perfect game to enjoy in short sessions or long competitions with yourself.",
        },
      ],
      features: [
        {
          title: "1. Real Bowling Feel",
          content:
            "Responsive controls and realistic pin movement make every roll feel true to the sport.",
        },
        {
          title: "2. Fun for Everyone",
          content:
            "Easy to learn, suitable for all ages  great for casual play or serious score chasing.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team carefully tuned every throw, bounce, and spin to feel responsive and authentic, giving players the feel of real bowling anytime, anywhere.",
        },
      ],
    },
  },
  {
    id: "breakline",
    name: "Break The Line",
    img: breakline,
    banner: require("../Assets/images/banner/break_the_line.jpg"),
    description: "Tap, break & pass the lines!",
    gamePath: "/Games/break_lines/index.htm",
    category: "Kids",
    type: "Latest",
    about: {
      heading: "Break The Line Online Free Game",
      sections: [
        {
          title: "1. What is Break The Line?",
          content:
            "Break The Line is a simple yet addictive arcade game developed by htmlh5games. Players shoot a ball to break lines in a single shot, with the number of lines increasing as levels progress, testing precision and timing.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Break The Line, each level challenges players to aim carefully and shatter all the lines at once. As players advance, the game becomes more challenging, requiring sharper focus and perfect shots to clear the screen.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Break The Line, each level challenges players to aim carefully and shatter all the lines at once. As players advance, the game becomes more challenging, requiring sharper focus and perfect shots to clear the screen.",
        },
      ],
      features: [
        {
          title: "1. Smash Your Way Forward with htmlh5games",
          content:
            "Enjoy the satisfaction of breaking lines with perfectly aimed shots! Simple controls, colorful visuals, and steadily increasing difficulty keep the game exciting and rewarding.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about crafting minimalist yet challenging arcade games. With Break The Line, we deliver quick, engaging fun that’s perfect for short breaks or long play sessions.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our dedicated developers and designers focus on intuitive gameplay and clean design. Their work ensures Break The Line feels smooth, responsive, and endlessly replayable.",
        },
      ],
    },
  },

  {
    id: "cluckroad",
    name: "Cluck And Road",
    img: cluckroad,
    banner: require("../Assets/images/banner/cluck_and_road.jpg"),
    description: "Guide your chicken safely across roads",
    gamePath: "/Games/cluck_crossing/index.htm",
    category: "Racing",
    type: "Trending",
    about: {
      heading: " Play Cluck And Road Online Free  ",
      sections: [
        {
          title: "1. What is Cluck And Road?",
          content:
            "Cluck And Road is a charming and endlessly fun arcade game on htmlh5games, where brave little chickens face the ultimate challenge: crossing busy roads filled with traffic and obstacles. Simple, silly, and completely addictive!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap and guide your chicken to hop forward, dodge cars, and find the perfect moment to keep moving. The goal? See how far you can go without getting squashed! Timing, quick reflexes, and a little bit of luck are the keys to a high score.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap and guide your chicken to hop forward, dodge cars, and find the perfect moment to keep moving. The goal? See how far you can go without getting squashed! Timing, quick reflexes, and a little bit of luck are the keys to a high score.",
        },
      ],
      features: [
        {
          title: "1. Just Cross & Go!",
          content:
            "No distractions just pure road-crossing fun. Focus on the simple thrill of jumping forward and avoiding obstacles.Bright visuals, funny animations, and randomly generated roads keep every run fresh and unpredictable.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create casual games that everyone can pick up and enjoy. Cluck And Road captures the humor and excitement of helping silly chickens survive busy streets.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team built Cluck And Road to be lightweight, responsive, and entertaining. Each run is quick, fun, and perfect for playing anytime, anywhere.",
        },
      ],
    },
  },
  {
    id: "blockmatch",
    name: "Block Match",
    img: blockmatch,
    banner: require("../Assets/images/banner/block_match.jpg"),
    description: "Match blocks & beat tricky levels!",
    gamePath: "/Games/block_matchup/index.htm",
    category: "Kids",
    type: "Featured",
    about: {
      heading: "Play Block Match Game Online Free",
      sections: [
        {
          title: "1. What is Block Match?",
          content:
            "Block Match is a colorful, brain-teasing puzzle game on htmlh5games, where your challenge is to match blocks of the same color or pattern and fit them perfectly into the given shape!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Drag, swap, or place blocks so matching colors or designs touch and complete the outlined shape on each level. Plan your moves carefully: every piece matters, and the right combination clears the stage and unlocks new puzzles!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Drag, swap, or place blocks so matching colors or designs touch and complete the outlined shape on each level. Plan your moves carefully: every piece matters, and the right combination clears the stage and unlocks new puzzles!",
        },
      ],

      features: [
        {
          title: "1. Relaxing Yet Strategic",
          content:
            "Easy to start, but every level brings new shapes and trickier matches to keep your brain engaged.Enjoy bright visuals, smooth animations, and satisfying moments when pieces click into place.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create puzzle experiences that mix relaxing gameplay with clever strategy. Block Match is all about finding joy in every perfect match.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our designers built a variety of beautiful block styles and crafted levels to keep players coming back for just one more puzzle.",
        },
      ],
    },
  },
  {
    id: "colorring",
    name: "Color Rings Puzzle",
    img: colorring,
    banner: require("../Assets/images/banner/color_rings_puzzle.jpg"),
    description: "Place rings & clear colorful combos!",
    gamePath: "/Games/rings_rumble/index.htm",
    category: "Sports",
    type: "Featured",
    about: {
      heading: "Color Rings Puzzle Online Free Game",
      sections: [
        {
          title: "1. What is Color Rings Puzzle?",
          content:
            "Color Rings Puzzle is a relaxing yet addictive puzzle game developed by htmlh5games. Players strategically place colorful rings on the board to match and clear them, enhancing pattern recognition, focus, and problem-solving skills.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Color Rings Puzzle, players drag and drop vibrant rings to form complete lines or circles of the same color. Once matched, the rings disappear, earning players points. The game offers soothing visuals, simple controls, and challenges suitable for all skill levels.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap and guide your chicken to hop forward, dodge cars, and find the perfect moment to keep moving. The goal? See how far you can go without getting squashed! Timing, quick reflexes, and a little bit of luck are the keys to a high score.",
        },
      ],
      features: [
        {
          title: "1. Dive into the Colorful World with htmlh5games",
          content:
            "Welcome to the delightful world of Color Rings Puzzle, where players can relax and train their minds through fun and engaging gameplay. Discover the joy of matching colors and beating your own high scores!",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about crafting puzzle games that entertain and inspire. With Color Rings Puzzle, we aim to deliver a calming yet challenging gaming experience for puzzle lovers everywhere.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our skilled developers and designers work hard to create visually appealing and rewarding games. Thanks to their dedication, Color Rings Puzzle captivates players with its elegant design and endless replay value.",
        },
      ],
    },
  },

  {
    id: "cosmicglide",
    name: "Cosmic Glide",
    img: cosmicglide,
    banner: require("../Assets/images/banner/cosmic_glide.jpg"),
    description: " Glide through space & avoid cosmic dangers!",
    gamePath: "/Games/cosmic_glide/index.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Play Cosmic Glide Online Free",
      sections: [
        {
          title: "1. What is Cosmic Glide?",
          content:
            "Cosmic Glide is a sleek and mesmerizing galaxy adventure on htmlh5games, where you pilot your ship through endless starlit pathways, dodging meteor fields, neon obstacles, and swirling cosmic storms.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Guide your spacecraft with smooth, gliding motions as you race through a glowing galactic tunnel. Avoid crashing into moving obstacles and meteor belts, and master sharp turns to keep your glide going. The deeper into space you go, the faster and more intense your journey becomes!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Guide your spacecraft with smooth, gliding motions as you race through a glowing galactic tunnel. Avoid crashing into moving obstacles and meteor belts, and master sharp turns to keep your glide going. The deeper into space you go, the faster and more intense your journey becomes!",
        },
      ],
      features: [
        {
          title: "1. Fast & Hypnotic Action",
          content:
            "Simple controls keep the gameplay accessible, but each run is a test of reflexes and focus as speed and obstacles increase.Enjoy glowing trails, starfields, and pulsing galactic colors that create a captivating sense of movement through the cosmos.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create arcade experiences that feel both thrilling and beautiful. Cosmic Glide blends endless gameplay with cosmic visuals for players who love to test their reflexes in style.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted Cosmic Glide to combine smooth, satisfying movement with a futuristic galaxy vibe making every run feel like an interstellar dance.",
        },
      ],
    },
  },
  // {
  //   id: "counterstrike",
  //   name: "Counter Strike 2",
  //   img: counterstrike,
  //   banner: require("../Assets/images/banner/counter_strike_2.jpg"),
  //   description: " Aim, shoot & outsmart opponents!",
  //   gamePath: "/Games/tactical_strike/index.html",
  //   category: "Action",
  //   type:"Trending",
  //   about: {
  //     heading: "Counter Strike 2 About Us",
  //     sections: [
  //       {
  //         title: "1. What is Counter Strike 2?",
  //         content:
  //           "Counter Strike 2 is an action shooting game developed by htmlh5games. Players take control of a soldier who must shoot and eliminate enemies from his fixed firing line, collecting coins after each successful takedown.",
  //       },
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "In Counter Strike 2, players aim and fire to defeat waves of enemies, earning coins to unlock upgrades and power-ups. Quick reflexes and sharp accuracy are key to surviving longer and climbing the leaderboard.",
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Step into the Action with htmlh5games",
  //         content:
  //           "Experience intense shooting gameplay where every shot counts! Eliminate enemies, collect coins, and enjoy the thrill of becoming a top shooter.",
  //       },
  //       {
  //         title: "2. Who Are We?",
  //         content:
  //           "htmlh5games is a creative team passionate about making action-packed shooting games. With 'Counter Strike 2', we deliver fast-paced gameplay that challenges players’ aim, timing, and focus.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "At htmlh5games, our talented developers and designers work hard to bring dynamic visuals and satisfying shooting mechanics to life. Their dedication ensures 'Counter Strike 2' is exciting, rewarding, and fun for every player.",
  //       },
  //     ],
  //   },
  // },
  {
    id: "basketchaps",
    name: "Basket Champs",
    img: basketchaps,
    banner: require("../Assets/images/banner/basket_champs.jpg"),
    description: "Sink shots & claim the championship!",
    gamePath: "/Games/dunk_land/index.htm",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Play Free Basket Champs Game ",
      sections: [
        {
          title: "1. What is Basket Champs?",
          content:
            "Basket Champs is a fun basketball shooting game where you pick your country and compete to become the best shooter in the world Aim carefully, score the most points, and move through exciting elimination rounds.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Basket Champs, players participate in exciting basketball matches where precision, timing, and strategy are key. With a variety of countries to represent, players shoot their way through elimination rounds, unlocking achievements and challenging new opponents at each level.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Basket Champs brings short, exciting matches that test your shooting skills. Every level introduces new opponents and higher stakes, making each victory rewarding. Whether you play for fun or high level competition, the thrill of scoring feels amazing.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Basket Champs",
          content:
            "Each match challenges your accuracy  time your shots and aim perfectly to outscore your opponent. Win your way through different countries and tournaments as the difficulty rises with every level.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Tap, drag, and release to shoot the basketball",
            "Adjust the angle and power for perfect shots",
            "Score more points than the opponent to advance",
            "Keep winning to reach the championship round",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Practice the right timing  each ball behaves differently",
            "Aim slightly above the hoop for cleaner shots",
            "Focus during pressure rounds  one shot can decide the win",
            "Learn from misses to improve accuracy each game",
          ],
        },
      ],
      features: [
        {
          title: "1. Shoot, Score & Compete",
          content:
            "Simple basketball mechanics combined with global tournament play keeps every match engaging and competitive.",
        },
        {
          title: "2. Enjoyable for All Ages",
          content:
            "Easy to pick up, fun to master  great for kids, families, and sports fans alike.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team at htmlh5games brings games like Basket Champs to life, ensuring every detail is optimized for fun and accessibility. Whether you're a casual player or a basketball enthusiast, our mission is to provide endless entertainment and learning opportunities. ",
        },
      ],
    },
  },
  {
    id: "cubes",
    name: "Cubes 2048",
    img: cubes,
    banner: require("../Assets/images/banner/cubes_2048.jpg"),
    description: "Merge cubes & reach 2048!",
    gamePath: "/Games/cube_fest/index.html",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Cubes 2048 Online Free Game",
      sections: [
        {
          title: "1. What is Cubes 2048?",
          content:
            "Cubes 2048 is an engaging pathfinding and reflex game on htmlh5games, where you must guide your explorer safely across shifting cubes. Collect coin and make high score. Every step must be carefully chosen, because one wrong move means game over!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap or swipe to indicate the way forward, helping your explorer walk across the cubes. Plan your path wisely, react to moving platforms, and stay alert — the challenge keeps growing as the journey continues. The goal is simple: keep moving forward, collect coins to create high score and survive as long as you can.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap or swipe to indicate the way forward, helping your explorer walk across the cubes. Plan your path wisely, react to moving platforms, and stay alert  the challenge keeps growing as the journey continues. The goal is simple: keep moving forward, collect coins to create high score and survive as long as you can.",
        },
      ],
      features: [
        {
          title: "1. Simple Yet Challenging",
          content:
            "Easy touch controls let anyone play, but only sharp focus and planning keep you alive. Navigate shifting platforms and tricky patterns that demand quick decisions.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning minimalist designs into tense, satisfying experiences. Cubes 2048 is about timing, instinct, and the thrill of every perfectly chosen step.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our designers crafted clean visuals, smooth movement, and challenging layouts to keep every run unique and rewarding.",
        },
      ],
    },
  },
  {
    id: "dadyhelper",
    name: "Daddy's Little Helper",
    img: dadyhelper,
    banner: require("../Assets/images/banner/daddys_little_helper.jpg"),
    description: " Tidy, clean & help around the house!",
    gamePath: "/Games/little_hands_helper/index.html",
    category: "Kids",
    typr: "Featured",
    about: {
      heading: "Daddy's Little Helper Online Free Game",
      sections: [
        {
          title: "1. What is Daddy's Little Helper?",
          content:
            "Daddy's Little Helper is a charming casual game developed by htmlh5games. Players step into the shoes of a helpful child, assisting their dad with household chores and fun activities to keep the home tidy and happy.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Daddy's Little Helper, players complete simple yet engaging tasks like cleaning rooms, organizing toys, watering plants, and fixing little problems around the house. The game combines playful tasks with a warm family theme that’s perfect for kids and families.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Daddy's Little Helper, players complete simple yet engaging tasks like cleaning rooms, organizing toys, watering plants, and fixing little problems around the house. The game combines playful tasks with a warm family theme that’s perfect for kids and families.",
        },
      ],
      features: [
        {
          title: "1. Have Fun Helping Out with htmlh5games",
          content:
            "Enjoy the joy of teamwork! Help dad around the house through playful mini-games and feel proud as you see the home sparkle.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team dedicated to making wholesome, family-friendly games. With Daddy's Little Helper, we inspire players to discover the fun and importance of helping at home.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers craft colorful visuals and easy-to-play mini-games. Their dedication ensures Daddy's Little Helper feels cheerful, heartwarming, and entertaining for players of all ages.",
        },
      ],
    },
  },
  {
    id: "dollcakemaker",
    name: "Doll Cake Maker",
    img: dollcakemaker,
    banner: require("../Assets/images/banner/doll_cake_maker.jpg"),
    description: "Bake, decorate & create sweet cakes!",
    gamePath: "/Games/doll_cake_maker/index.html",
    category: "Kids",
    type: "Trending",
    about: {
      heading: "Play Doll Cake Maker Online Free",
      sections: [
        {
          title: "1. What is Doll Cake Maker?",
          content:
            "Doll Cake Maker is a fun and creative cooking game on htmlh5games, where you shop for ingredients and decorate your very own beautiful doll cake! Perfect for players who love baking, designing, and adding sweet finishing touches.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Start by heading to the store to buy flour, sugar, cream, decorations, and everything you need. Back in the kitchen, mix, bake, and build your cake layer by layer. Then design the dress: swirl colorful icing, add sparkly candies, and create the prettiest doll cake you can imagine!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Start by heading to the store to buy flour, sugar, cream, decorations, and everything you need. Back in the kitchen, mix, bake, and build your cake layer by layer. Then design the dress: swirl colorful icing, add sparkly candies, and create the prettiest doll cake you can imagine!",
        },
      ],
      features: [
        {
          title: "1. Shop & Bake Adventure",
          content:
            "Buy fresh ingredients, then transform them into a stunning cake masterpiece. Customize every detail from frosting colors to edible gems and decorative flowers.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we turn everyday moments into magical games. Doll Cake Maker mixes creativity, baking, and a little sparkle for players of all ages.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed each ingredient, frosting swirl, and decoration to look colorful and delicious, making every cake feel special.",
        },
      ],
    },
  },
  {
    id: "drawclimber",
    name: "Draw Climber",
    img: drawclimber,
    banner: require("../Assets/images/banner/draw_climber.jpg"),
    description: "Draw legs & climb to victory!",
    gamePath: "/Games/draw_crawler/index.htm",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Draw Climber Online Free Game",
      sections: [
        {
          title: "1. What is Draw Climber?",
          content:
            "Draw Climber is a hilarious and creative racing game on htmlh5games, where you don’t just race you draw your racer’s legs! Watch your blocky character come to life as your drawings help it roll, climb, and bounce past crazy obstacles.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Draw different shapes for legs to help your character overcome tricky tracks, high walls, and moving traps. Need more speed? Draw longer legs! Stuck on stairs? Try short and quick ones! Every level is a new challenge, and every drawing changes how your climber moves.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Draw different shapes for legs to help your character overcome tricky tracks, high walls, and moving traps. Need more speed? Draw longer legs! Stuck on stairs? Try short and quick ones! Every level is a new challenge, and every drawing changes how your climber moves.",
        },
      ],
      features: [
        {
          title: "1. Draw & Race Fun",
          content:
            "Unique gameplay where your creativity directly controls how your racer moves. Face moving platforms, spiky walls, deep pits, and funny surprises that keep every race fresh.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning simple ideas into endlessly fun games. Draw Climber is the perfect mix of creativity, racing, and humor.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted smooth animations, cheerful graphics, and silly physics so every race feels different  and every drawing feels important.",
        },
      ],
    },
  },

  {
    id: "dunkline",
    name: "Dunk Line",
    img: dunkline,
    banner: require("../Assets/images/banner/dunk_line.jpg"),
    description: " Draw lines & dunk the ball!",
    gamePath: "/Games/dunk_line/index.htm",
    category: "Sports",
    type: "Latest",
    about: {
      heading: "Play Free Dunk Line Game ",
      sections: [
        {
          title: "1. What is Dunk Line?",
          content:
            "Dunk Line is a creative and addictive drawing puzzle on htmlh5games, where you don’t throw the ball  you draw its path! Sketch lines to guide the falling basketball straight into the hoop, and show off your perfect shots.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Use your finger to draw lines that bounce, roll, or slide the basketball into the basket. Plan your moves quickly, as balls keep dropping one after another. Stay sharp, think fast, and keep dunking to climb your high score!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Use your finger to draw lines that bounce, roll, or slide the basketball into the basket. Plan your moves quickly, as balls keep dropping one after another. Stay sharp, think fast, and keep dunking to climb your high score!",
        },
      ],
      features: [
        {
          title: "1. Draw & Dunk",
          content:
            "Combine drawing creativity with real-time puzzle solving for endless fun.Balls keep coming  react fast, draw smarter, and see how long you can keep dunking.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love games that mix creativity with quick reflexes. Dunk Line turns every line you draw into a highlight moment.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers balanced timing, drawing mechanics, and scoring to keep every dunk feeling rewarding and fresh.",
        },
      ],
    },
  },
  {
    id: "energyball",
    name: "Energy Ball",
    img: energyball,
    banner: require("../Assets/images/banner/energy_ball.jpg"),
    description: "Launch energy & clear the stage!",
    gamePath: "/Games/energy_reserves/index.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Energy Ball Online Free Game",
      sections: [
        {
          title: "1. What is Energy Ball?",
          content:
            "Energy Ball is a fast-paced, reflex-driven arcade game on htmlh5games, where you guide a glowing energy sphere through dynamic paths, obstacles, and power fields  all while collecting energy to keep your ball charged and moving forward.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Control the bright, electric ball with quick swipes or taps to dodge barriers, jump over traps, and stay on course. Gather energy orbs to boost your score and unlock new skins or trails. The longer you keep rolling, the faster and more intense the challenge becomes!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Control the bright, electric ball with quick swipes or taps to dodge barriers, jump over traps, and stay on course. Gather energy orbs to boost your score and unlock new skins or trails. The longer you keep rolling, the faster and more intense the challenge becomes!",
        },
      ],
      features: [
        {
          title: "1. Addictive Reflex Action",
          content:
            "Simple controls meet thrilling speed, pushing your reaction time to the limit. Grab energy orbs to unlock new glowing effects and unique ball designs.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning minimalist designs into exciting, endless challenges. Energy Ball is all about quick thinking, fluid movement, and keeping the spark alive.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers crafted sleek visuals, smooth controls, and perfectly balanced levels for that just one more try thrill.",
        },
      ],
    },
  },
  {
    id: "flightdash",
    name: "Flight Dash",
    img: flightdash,
    banner: require("../Assets/images/banner/flight_dash.jpg"),
    description: "Dash through skies & dodge obstacles!",
    gamePath: "/Games/dark_flight_dash/index.htm",
    category: "Action",
    type: "Featured",
    about: {
      heading: "Play Flight Dash Game Online",
      sections: [
        {
          title: "1. What is Flight Dash?",
          content:
            "Flight Dash is an endless flying adventure on htmlh5games, where you guide a fearless character who soars across the sky dodging obstacles, gliding through clouds, and chasing the horizon. Feel the thrill of freedom and speed as you dash higher and further!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Take off and steer your character left, right, up, or down to dodge flying obstacles and collect power boosts. The challenge keeps growing as you fly faster and face new sky-high surprises. How far can you dash before the sky says game over?",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Take off and steer your character left, right, up, or down to dodge flying obstacles and collect power boosts. The challenge keeps growing as you fly faster and face new sky-high surprises. How far can you dash before the sky says game over?",
        },
      ],
      features: [
        {
          title: "1. Smooth & Addictive Flight",
          content:
            "Simple tap or swipe controls make it easy to play, while increasing speed keeps every run exciting. Glide under starlit skies with glowing silhouettes, soft moonlight, and gentle particle effects that make every run feel magical.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we design games that combine fast action with an endless sense of fun. Flight Dash is made for players who love quick reflexes, bright visuals, and the joy of flight.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "From smooth flight controls to charming character design and dynamic obstacles, our creative team built Flight Dash to deliver endless sky-high fun anytime you play.",
        },
      ],
    },
  },
  {
    id: "footballsoccer",
    name: "Football Soccer",
    img: footballsoccer,
    banner: require("../Assets/images/banner/football_soccer.jpg"),
    description: "Pass, dribble & score winning goals!",
    gamePath: "/Games/goal_strike/index.html",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Football Soccer Online Free Game",
      sections: [
        {
          title: "1. What is Football Soccer?",
          content:
            "Football Soccer is an exciting goal-scoring challenge game on htmlh5games, where your ultimate mission is to outsmart the goalkeeper and shoot the ball straight into the net! It’s all about timing, power, and precision!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "You take control of the striker with one goal  score! Aim carefully, dodge the agile goalkeeper, and shoot the ball past the defense to rack up goals. Each round gets more intense, with the goalkeeper getting smarter and faster. Test your skills and see how many goals you can make in a row without missing!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "You take control of the striker with one goal  score! Aim carefully, dodge the agile goalkeeper, and shoot the ball past the defense to rack up goals. Each round gets more intense, with the goalkeeper getting smarter and faster. Test your skills and see how many goals you can make in a row without missing!",
        },
      ],
      features: [
        {
          title: "1. Easy to Play, Hard to Master",
          content:
            "With simple tap controls and realistic ball movement, Football Soccer is perfect for quick, skill based fun. As you progress, the challenge increases with faster reactions required to beat the goalie.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we aim to bring football thrills to your screen. Football Soccer captures the tension and joy of scoring the perfect goal, making it ideal for players who love football action and fast-paced challenges.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Crafted with energy and passion, our team designed Football Soccer to deliver a pure shooting experience. The game features smooth animation, increasing difficulty, and rewarding goal effects to keep every shot exciting.",
        },
      ],
    },
  },

  {
    id: "fuzzbugs",
    name: "Fuzz Bugs",
    img: fuzzbugs,
    banner: require("../Assets/images/banner/fuzz_bugs.jpg"),
    description: "Play games & collect colorful fuzzies!",
    gamePath: "/Games/fuzzy_blend_bash/index.html",
    category: "Sports",
    type: "Featured",
    about: {
      heading: "Play Fuzz Bugs Online Free",
      sections: [
        {
          title: "1. What is Fuzz Bugs?",
          content:
            "Fuzz Bugs is a fun, family-friendly puzzle game on htmlh5games, where you guide cute, fluffy bugs through colorful mazes and tricky paths  matching colors and collecting items along the way!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Move your fuzzy little bugs around the board, guiding them to match areas of the same color. Solve light puzzles, dodge obstacles, and pick up bonus items to boost your score. It’s relaxing, playful, and perfect for all ages!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Move your fuzzy little bugs around the board, guiding them to match areas of the same color. Solve light puzzles, dodge obstacles, and pick up bonus items to boost your score. It’s relaxing, playful, and perfect for all ages!",
        },
      ],
      features: [
        {
          title: "1. Cute & Colorful Bugs",
          content:
            "Play with adorable fuzz bugs, each with its own fun personality and style. Light strategy and colorful matching  easy to play, but always rewarding. Pick up special items and complete each level to unlock new fuzz bug designs.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love making charming, feel-good games that bring smiles to every player.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our artists and developers created bright worlds, happy characters, and puzzles that are both relaxing and satisfying.",
        },
      ],
    },
  },
  {
    id: "galaxy",
    name: "Galaxy Attack-Shooting Games",
    img: galaxy,
    banner: require("../Assets/images/banner/galexy_atteck_shooting_games.jpg"),
    description: " Blast aliens & save the galaxy!",
    gamePath: "/Games/malware_defense/index.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Play Galaxy Attack-Shooting Game Online Free",
      sections: [
        {
          title: "1. What is Galaxy Attack – Shooting Games?",
          content:
            "Galaxy Attack  Shooting Games is a thrilling space shooter game available on htmlh5games. Become a space hero as you pilot your powerful spaceship through an endless wave of alien invaders, asteroids, and boss battles in an epic intergalactic war!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Galaxy Attack, your mission is to defend Earth and the galaxy from enemy forces. Control your spaceship with smooth, intuitive movements and blast through waves of alien ships. Collect power-ups, upgrade your weapons, and face off against massive bosses as you advance through the galaxy. Reflexes, strategy, and firepower are your keys to survival.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Galaxy Attack, your mission is to defend Earth and the galaxy from enemy forces. Control your spaceship with smooth, intuitive movements and blast through waves of alien ships. Collect power ups, upgrade your weapons, and face off against massive bosses as you advance through the galaxy. Reflexes, strategy, and firepower are your keys to survival.",
        },
      ],
      features: [
        {
          title: "1. Blast Through the Stars",
          content:
            "With dynamic shooting action, stunning cosmic visuals, and challenging levels, Galaxy Attack delivers a true space battle experience. Each stage brings new enemies, faster attacks, and thrilling surprises.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring action and excitement to your fingertips. Galaxy Attack – Shooting Games is designed for players who love high-speed space combat, sharp reflexes, and epic missions across the stars.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team at htmlh5games has crafted Galaxy Attack with precision and excitement in mind. From powerful weapons to intense gameplay and epic space environments, every detail is designed to immerse players in the ultimate galactic showdown.",
        },
      ],
    },
  },
  {
    id: "geometry",
    name: "Geometry Dash",
    img: geometry,
    banner: require("../Assets/images/banner/geometry_dash.jpg"),
    description: "Dash, jump & avoid every spike!",
    gamePath: "/Games/cosmic_cyclone/index.htm",
    category: "Kids",
    type: "Latest",
    about: {
      heading: "Play Free Geometry Dash Game Online ",
      sections: [
        {
          title: "1. What is this Geometry Dash?",
          content:
            "It’s a fast-paced, reflex-based arcade challenge on htmlh5games, where your explorer stands in the center of a spinning circle sliced by sharp gaps. You must change the explorer’s direction in perfect timing so the arrow passes safely through the cuts  avoid collision to stay alive and set new high scores",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap to rotate the explorer’s arrow in the center. As the circle spins, line up the arrow with the cut in the circle to avoid hitting the edge. The longer you survive, the faster the circle spins and the smaller the cuts become  demanding sharper reflexes and split-second decisions.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap to rotate the explorer’s arrow in the center. As the circle spins, line up the arrow with the cut in the circle to avoid hitting the edge. The longer you survive, the faster the circle spins and the smaller the cuts become  demanding sharper reflexes and split second decisions.",
        },
      ],
      features: [
        {
          title: "1. Simple Controls, Tough Challenge",
          content:
            "Easy to learn  just tap to change direction  but only perfect timing will keep you alive. Chase your best score with each run getting faster and more intense. Minimalist design with bold shapes, smooth spins, and a sleek explorer at the center.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning simple mechanics into skillful challenges. This game is about reflexes, patience, and the thrill of barely making it through!",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers carefully balanced speed, gaps, and direction changes to keep every attempt exciting and reward perfect timing.",
        },
      ],
    },
  },
  //  {
  //   id: "jungleadventure",
  //   name: "Jungle Adventure",
  //   img: jungleadventure,
  //   banner: require("../Assets/images/banner/jungle_adventure.jpg"),
  //   description: "Run, jump & explore the jungle!",
  //   gamePath: "/Games/divine_adventure/index.html",
  //   category: "Adventure",
  //   type:"Latest",
  //   about: {
  //     heading: "Jungle Adventure About Us",
  //     sections: [
  //       {
  //         title: "1. What is Jungle Adventure?",
  //         content:
  //           "Jungle Adventure is an action-packed platformer on htmlh5games, where you run, jump, and explore your way through mysterious jungles full of danger and hidden treasure! Swing on vines, dodge traps, and outsmart jungle creatures as you journey deeper into the wild.",
  //       },
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "Guide your brave explorer through lush forests, ancient ruins, and secret caves. Collect fruits, coins, and magical power-ups to unlock new abilities and survive tougher levels. Each stage brings fresh obstacles  from quicksand pits and rolling boulders to cheeky monkeys and fierce wild beasts!",
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Classic Platformer Adventure",
  //         content:
  //           "Easy controls, smooth movement, and timeless jump-and-run action that anyone can enjoy. Discover beautifully designed jungle levels, secret paths, and hidden rewards that keep every playthrough exciting.",
  //       },
  //       {
  //         title: "2. Who Are We?",
  //         content:
  //           "At htmlh5games, we bring classic adventure gameplay to modern players. Jungle Adventure captures the magic of old-school platformers with fresh visuals and fun surprises.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "Our creative team handcrafted each obstacle, creature, and power-up to balance challenge and fun, making every run feel like a new adventure.",
  //       },
  //     ],
  //   },
  // },
  {
    id: "gigglebarbie",
    name: "Giggle Babies-Toddler Care",
    img: gigglebarbie,
    banner: require("../Assets/images/banner/giggle_babies_toddler_care.jpg"),
    description: "Giggle, play & care for little ones!",
    gamePath: "/Games/baby_toddler_care/index.html",
    category: "Kids",
    type: "Featured",
    about: {
      heading: "Giggle Babies-Toddler Care Online Free Game",
      sections: [
        {
          title: "1. What is Giggle Babies – Toddler Care?",
          content:
            "Giggle Babies – Toddler Care is a super cute and interactive baby care simulation game featured on htmlh5games. Step into the role of a caring babysitter and look after a group of happy, giggling toddlers who need love, attention, and lots of fun!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Giggle Babies, you’ll take care of adorable toddlers by feeding them, changing their diapers, giving them baths, dressing them in sweet outfits, and playing with them using toys and fun mini-games. Each giggle and smile is your reward as you help them stay happy and healthy.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Giggle Babies, you’ll take care of adorable toddlers by feeding them, changing their diapers, giving them baths, dressing them in sweet outfits, and playing with them using toys and fun mini-games. Each giggle and smile is your reward as you help them stay happy and healthy.",
        },
      ],
      features: [
        {
          title: "1. Love, Laugh, and Learn",
          content:
            "With cheerful animations, gentle music, and interactive tasks, Giggle Babies – Toddler Care helps players learn about responsibility, empathy, and everyday routines while having a blast with their tiny virtual friends.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we’re committed to designing joyful, educational, and safe games for children. Giggle Babies – Toddler Care is crafted to nurture young players' creativity and caregiving instincts in a bright, friendly environment",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team at htmlh5games has built 'Giggle Babies' with love and care from the cute baby giggles to the playful visuals and easy controls. Every detail is made to keep kids smiling, learning, and engaged.",
        },
      ],
    },
  },
  {
    id: "geometrylite",
    name: "Geometry Dash Lite",
    img: geometrylite,
    banner: require("../Assets/images/banner/geometry_dash_lite.jpg"),
    description: "Jump, fly & dodge the spikes!",
    gamePath: "/Games/geometry_dash/index.html",
    category: "Adventure",
    type: "Featured",
    about: {
      heading: "Play Geometry Dash Lite Online Free",
      sections: [
        {
          title: "1. What is Geometry Dash Lite?",
          content:
            "Geometry Dash Lite is an addictive rhythm based platformer on htmlh5games, where you guide a cube through neon worlds full of spikes, jumps, and pulse-pounding beats. One wrong move and it’s back to the start!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap to jump, fly, and flip your way through tricky levels packed with geometric obstacles and dynamic music. Timing and rhythm are everything! The further you go, the faster and more challenging it becomes testing your reflexes, patience, and memory.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap to jump, fly, and flip your way through tricky levels packed with geometric obstacles and dynamic music. Timing and rhythm are everything! The further you go, the faster and more challenging it becomes testing your reflexes, patience, and memory.",
        },
      ],
      features: [
        {
          title: "1. Rhythm & Reflex Challenge",
          content:
            "Simple one-touch controls keep the game easy to pick up, but every level demands precision and perfect timing to master. Enjoy colorful, pulsing visuals that move in sync with energetic electronic music tracks, creating a thrilling, immersive experience.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring fast, fun, and challenging arcade games to players of all ages. Geometry Dash Lite offers endless replay value, combining music and action in the most addictive way.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted every jump, beat, and obstacle to deliver intense, frustration-fueled fun where each almost! keeps you coming back for another try.",
        },
      ],
    },
  },

  {
    id: "hexaquest",
    name: "Hexa Quest-Block Puzzle",
    img: hexaquest,
    banner: require("../Assets/images/banner/hexa_quest_block_puzzle.jpg"),
    description: "Place blocks & clear the quest!",
    gamePath: "/Games/hexa_quest/index.html",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Hexa Quest-Block Puzzle Online",
      sections: [
        {
          title: "1. What is Hexa Quest – Block Puzzle?",
          content:
            "Hexa Quest – Block Puzzle is an exciting blend of brain-teasing puzzles and heroic adventure, featured on htmlh5games. In this unique game, every puzzle you solve gives your hero more power to battle evil villains and protect the realm!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Hexa Quest, players must drag and fit colorful hexagonal blocks into the grid to complete lines and solve challenging puzzles. Each successful move charges up your hero’s energy bar. Once it’s full, your hero unleashes powerful attacks against the villain. The better you play, the stronger your hero becomes!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Hexa Quest, players must drag and fit colorful hexagonal blocks into the grid to complete lines and solve challenging puzzles. Each successful move charges up your hero’s energy bar. Once it’s full, your hero unleashes powerful attacks against the villain. The better you play, the stronger your hero becomes!",
        },
      ],
      features: [
        {
          title: "1. Puzzle, Power, and Adventure",
          content:
            "Hexa Quest combines the logic and fun of block puzzles with the thrill of a fantasy battle. With every puzzle cleared, you advance your hero's journey toward defeating powerful enemies and restoring peace to the land",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love combining gameplay with storytelling. Hexa Quest – Block Puzzle is designed to challenge the mind while offering an exciting sense of purpose, making it both smart and action-packed fun for all ages.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team at htmlh5games crafted Hexa Quest to be more than just a puzzle game. With vibrant visuals, smooth controls, and an epic storyline, we’ve built a world where logic meets legend and your brain becomes your superpower!",
        },
      ],
    },
  },

  {
    id: "hotlava",
    name: "Hot Lava Volcano Game",
    img: hotlava,
    banner: require("../Assets/images/banner/hot_lava_volcano_game.jpg"),
    description: "Roll, jump & dodge the lava!",
    gamePath: "/Games/escape_volcano_lava/index.htm",
    category: "Adventure",
    type: "Featured",
    about: {
      heading: "Play Free Hot Lava Volcano Game Online",
      sections: [
        {
          title: "1. What is Hot Lava Volcano?",
          content:
            "Hot Lava Volcano is an exciting arcade adventure game developed by htmlh5games. Players guide a brave rolling ball explorer through fiery volcanic landscapes, avoiding molten lava and other dangerous obstacles.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Hot Lava Volcano, players control the ball to jump, roll, and dodge through challenging levels filled with lava pits, falling rocks, and tricky platforms. Quick reactions and careful timing are key to surviving and reaching new areas.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Hot Lava Volcano, players control the ball to jump, roll, and dodge through challenging levels filled with lava pits, falling rocks, and tricky platforms. Quick reactions and careful timing are key to surviving and reaching new areas.",
        },
      ],
      features: [
        {
          title: "1. Brave the Heat with htmlh5games",
          content:
            "Step into a scorching adventure! Navigate your ball safely through bubbling lava, unpredictable terrain, and intense heat in a thrilling test of skill.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about making fun and challenging arcade adventures. With Hot Lava Volcano, we invite players to explore dangerous yet captivating volcanic worlds.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers build vibrant, lava-filled environments and smooth controls. Their dedication ensures Hot Lava Volcano feels exciting, dynamic, and endlessly replayable.",
        },
      ],
    },
  },
  {
    id: "icytower",
    name: "Icy Tower",
    img: icytower,
    banner: require("../Assets/images/banner/icy_tower.jpg"),
    description: " Jump higher & climb the icy tower!",
    gamePath: "/Games/jump_ascend/index.htm",
    category: "Adventure",
    type: "Featured",
    about: {
      heading: "Icy Tower Online Free Game ",
      sections: [
        {
          title: "1. What is Icy Tower?",
          content:
            "Icy Tower is a classic arcade-style jumping game on htmlh5games, where you help an adventurous explorer bounce ever higher by leaping from one wooden strip to the next. Quick reflexes and perfect timing are your best friends on the climb to the top!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Use the arrow keys to jump between strips. Jump quickly to keep moving up  slow down, and you risk falling. The higher you go, the faster the tower scrolls, turning each moment into a test of skill and focus. Stay alive, keep climbing, and beat your best score!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Use the arrow keys to jump between strips. Jump quickly to keep moving up  slow down, and you risk falling. The higher you go, the faster the tower scrolls, turning each moment into a test of skill and focus. Stay alive, keep climbing, and beat your best score!",
        },
      ],
      features: [
        {
          title: "1. Fast & Addictive Action",
          content:
            "Simple controls and quick jumps make it easy to start  but reaching the top is a true challenge. No finish line  just your reflexes, skill, and the thrill of beating your last record",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring classic arcade fun to everyone. Icy Tower turns a simple idea into an endlessly replayable game that keeps players coming back.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers crafted smooth jumping mechanics, clean retro visuals, and that just one more jump feeling every great arcade game needs.",
        },
      ],
    },
  },

  {
    id: "magictiles",
    name: "Magic Tiles 3",
    img: magictiles,
    banner: require("../Assets/images/banner/magic_tiles_3.jpg"),
    description: " Tap to the beat & master the music!",
    gamePath: "/Games/jingle_bell_beats/index.htm",
    category: "Action",
    type: "Latest",
    about: {
      heading: "Play Magic Tiles 3 Game Online",
      sections: [
        {
          title: "1. What is Magic Tiles 3?",
          content:
            "Magic Tiles 3 – Christmas Edition is a festive, musical tapping game available on htmlh5games, where the magic of music meets the joy of Christmas! Players tap on cheerful dancing Santas set in a snowy, holiday-themed background all to the rhythm of catchy tunes and Christmas carols.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In this fun-filled holiday version of the classic music game, your goal is to tap on the moving Santas in perfect timing with the music. The more accurately you tap, the higher your score! With increasing speed and holiday jingles, the challenge and excitement keep building with every beat. One missed tap, and Santa might slip!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In this fun-filled holiday version of the classic music game, your goal is to tap on the moving Santas in perfect timing with the music. The more accurately you tap, the higher your score! With increasing speed and holiday jingles, the challenge and excitement keep building with every beat. One missed tap, and Santa might slip!",
        },
      ],
      features: [
        {
          title: "1. Tap to the Jingle Beats",
          content:
            "This festive version of Magic Tiles 3 adds a magical Christmas twist to musical rhythm gameplay. Colorful graphics, dancing Santas, snowflakes, and classic carols make every tap a celebration of the season.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring joyful twists to popular games for players of all ages. Magic Tiles 3 – Christmas Edition spreads happiness and rhythm through gameplay that enhances focus, timing, and musical memory all in a cozy Christmas setting.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team at htmlh5games reimagined the classic Magic Tiles 3 with holiday cheer. From the charming animations to the festive music and Santa-themed tiles, every detail is crafted to create the ultimate Christmas rhythm challenge.",
        },
      ],
    },
  },
  {
    id: "manicminer",
    name: "Manic Miner-Spectrum",
    img: manicminer,
    banner: require("../Assets/images/banner/manic_miner_spectrum.jpg"),
    description: "Mine, jump & survive classic challenges!",
    gamePath: "/Games/spin_spectrum/index.htm",
    category: "Sports",
    type: "Featured",
    about: {
      heading: "Manic Miner-Spectrum Online Free Game",
      sections: [
        {
          title: "1. What is Manic Miner – Spectrum?",
          content:
            "Manic Miner – Spectrum is a colorful, reflex-based arcade game featured on htmlh5games, where classic miner fun meets a brand-new color matching twist! Instead of digging through caves, your running hero must match the knife’s color with the right segment of a spinning circle to keep moving forward.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "As the miner’s knife keeps running around the spinning circle, you must quickly change its color to match the upcoming color on the circle’s edge. Time it perfectly  one wrong color, and the game ends! The more you match, the faster and trickier it gets, testing your reflexes, focus, and timing.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "As the miner’s knife keeps running around the spinning circle, you must quickly change its color to match the upcoming color on the circle’s edge. Time it perfectly  one wrong color, and the game ends! The more you match, the faster and trickier it gets, testing your reflexes, focus, and timing.",
        },
      ],
      features: [
        {
          title: "1. Match & Run",
          content:
            "Simple to play but hard to master! Quickly switch colors and keep your knife moving around the circle in a rhythmic, endless challenge. Enjoy vibrant Spectrum-inspired colors, smooth animations, and arcade-style sound effects that bring classic retro energy to a modern game.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love transforming classic gameplay into fresh, fun challenges. Manic Miner – Spectrum keeps the nostalgic charm alive while adding a new reflex-based color twist.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team carefully crafted a game where classic style meets quick thinking. With fast gameplay, eye-catching colors, and satisfying controls, every match feels rewarding and fun.",
        },
      ],
    },
  },
  {
    id: "matchmaster",
    name: "Match Master",
    img: matchmaster,
    banner: require("../Assets/images/banner/match_master.jpg"),
    description: "Match tiles & master every level!",
    gamePath: "/Games/match_master/index.html",
    category: "Racing",
    type: "Latest",
    about: {
      heading: "Play Free Match Master Online Game",
      sections: [
        {
          title: "1. What is Match Master?",
          content:
            "Match Master is a colorful and endlessly fun puzzle game on htmlh5games, where your goal is to match, combine, and clear tiles to score big! Fast, rewarding, and perfect for players who love quick challenges and satisfying combos.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swipe to connect matching tiles in rows or clusters. Create bigger chains for special power-ups and watch the board come alive with pops, flashes, and explosions. The quicker you think, the higher your combo and the closer you get to becoming a true Match Master!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Swipe to connect matching tiles in rows or clusters. Create bigger chains for special power-ups and watch the board come alive with pops, flashes, and explosions. The quicker you think, the higher your combo and the closer you get to becoming a true Match Master!",
        },
      ],
      features: [
        {
          title: "1. Fast & Addictive Puzzle Action",
          content:
            "Simple controls let anyone play, but mastering combos and beating high scores takes real skill. Enjoy bright graphics, smooth animations, and special tiles that keep every match exciting.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we craft casual games that are easy to pick up yet hard to put down. Match Master brings classic matching gameplay to life with modern flair.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed every pop, combo, and boost to feel rewarding, turning each game into a colorful celebration of quick thinking.",
        },
      ],
    },
  },

  {
    id: "mybabycare",
    name: "My Baby Care",
    img: mybabycare,
    banner: require("../Assets/images/banner/my_baby_care.jpg"),
    description: "Nurture, love, and care for your baby!",
    gamePath: "/Games/caring_corner_tale/index.html",
    category: "Kids",
    type: "Latest",
    about: {
      heading: "Play My Baby Care Game Online",
      sections: [
        {
          title: "1. What is My Baby Care?",
          content:
            "My Baby Care is a fun and educational simulation game featured on htmlh5games, where players step into the role of a caregiver and look after adorable virtual babies. From feeding and bathing to dressing and playing, the game provides a joyful and nurturing experience.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In My Baby Care, players are responsible for taking care of cute little babies throughout their daily routines. You'll feed them, change diapers, give them a bath, dress them in lovely outfits, and keep them entertained with toys and mini-games. It's perfect for kids who love to play family or care games.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In My Baby Care, players are responsible for taking care of cute little babies throughout their daily routines. You'll feed them, change diapers, give them a bath, dress them in lovely outfits, and keep them entertained with toys and mini games. It's perfect for kids who love to play family or care games.",
        },
      ],
      features: [
        {
          title: "1. Nurture, Play, and Learn",
          content:
            "My Baby Care encourages empathy, responsibility, and creativity. With colorful graphics, smooth gameplay, and interactive tasks, children can explore what it's like to care for a baby while having fun.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we specialize in creating family-friendly and value driven games. My Baby Care is designed to help young players learn basic nurturing skills in a fun and interactive way perfect for future big brothers, sisters, or young caregivers at heart.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "The team at htmlh5games focuses on developing wholesome, engaging, and educational content. My Baby Care combines simple controls, charming visuals, and thoughtful design to ensure a delightful experience for children of all ages.",
        },
      ],
    },
  },
  {
    id: "mysticmatch",
    name: "Mystic Match",
    img: mysticmatch,
    banner: require("../Assets/images/banner/mystic_match.jpg"),
    description: "Match gems & unlock magical worlds!",
    gamePath: "/Games/mystic_matchup/index.htm",
    category: "Kids",
    type: "Trending",
    about: {
      heading: "Mystic Match Online Free Game",
      sections: [
        {
          title: "1. What is Mystic Match?",
          content:
            "Mystic Match is a puzzle adventure on htmlh5games, where players journey through enchanted lands, solving colorful puzzles to unlock new levels, spells, and mysteries hidden within a mystic world.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swap and match gems, potions, or magical symbols to clear levels and create powerful combos. Complete objectives, unlock special boosters, and overcome obstacles that bring new challenges to every level. The deeper you go, the more magical and tricky the puzzles become!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Swap and match gems, potions, or magical symbols to clear levels and create powerful combos. Complete objectives, unlock special boosters, and overcome obstacles that bring new challenges to every level. The deeper you go, the more magical and tricky the puzzles become!",
        },
      ],
      features: [
        {
          title: "1. Match, Combine & Conquer",
          content:
            "Simple to learn, yet deeply satisfying! Create dazzling combos, break enchanted barriers, and discover powerful boosters that help you master tougher puzzles. Enjoy beautifully drawn backgrounds, charming animations, and magical sound effects that bring the fantasy world of Mystic Match to life.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning classic gameplay into enchanting experiences. Mystic Match combines the fun of match-3 puzzles with a fantasy adventure theme to keep every player engaged.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team designed Mystic Match with smooth gameplay, magical visuals, and thoughtfully crafted levels ensuring each match feels rewarding and each new stage feels like a discovery.",
        },
      ],
    },
  },

  {
    id: "pingpong",
    name: "Ping Pong-Table Tennis",
    img: pingpong,
    banner: require("../Assets/images/banner/ping_pong_table_tennis.jpg"),
    description: " Rally fast & score points!",
    gamePath: "/Games/spin_shot/index.htm",
    category: "Sports",
    type: "Latest",
    about: {
      heading: "Play Ping Pong-Table Tennis Game Online",
      sections: [
        {
          title: "1. What is Ping Pong - Table Tennis?",
          content:
            "Ping Pong - Table Tennis is an exciting sports game developed by htmlh5games. Players test their reflexes and precision by rallying a fast moving ball across the table, improving hand eye coordination, timing, and strategic thinking.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Ping Pong - Table Tennis, players swipe to serve, spin, and smash the ball against their opponent to score points. The game features realistic physics, smooth controls, and dynamic matches that challenge players of all skill levels.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Ping Pong - Table Tennis, players swipe to serve, spin, and smash the ball against their opponent to score points. The game features realistic physics, smooth controls, and dynamic matches that challenge players of all skill levels.",
        },
      ],
      features: [
        {
          title: "1. Step into the World of Table Tennis with htmlh5games",
          content:
            "Experience the thrill of competitive table tennis in a fun and interactive way. Sharpen your reflexes, master tricky spins, and enjoy immersive matches anytime, anywhere!",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a passionate team focused on delivering high quality sports games. With Ping Pong - Table Tennis, we aim to bring the excitement of real table tennis to your screen, offering a blend of entertainment and skill based gameplay.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our dedicated developers and designers create engaging and authentic table tennis experiences. Their expertise ensures that every match feels realistic and rewarding, keeping players hooked worldwide.",
        },
      ],
    },
  },
  {
    id: "pixelshuffle",
    name: "Pixel Shuffle",
    img: pixelshuffle,
    banner: require("../Assets/images/banner/pixel_shuffle.jpg"),
    description: "Shuffle tiles & test your puzzle skills!",
    gamePath: "/Games/pixel_shuffle/index.html",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Pixel Shuffle Online Free Game",
      sections: [
        {
          title: "1. What is Pixel Shuffle?",
          content:
            "Pixel Shuffle is a creative and fast paced shape matching runner game available on htmlh5games. In this unique and challenging adventure, players must transform their running object to match the shape of oncoming obstacles and pass through without crashing!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Pixel Shuffle, your pixel character keeps running forward as different shape walls appear. Your task is to quickly change the pixel formation to match the opening in the wall. Timing, observation, and quick thinking are the keys to survival. The further you go, the faster and trickier it becomes!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Pixel Shuffle, your pixel character keeps running forward as different shape walls appear. Your task is to quickly change the pixel formation to match the opening in the wall. Timing, observation, and quick thinking are the keys to survival. The further you go, the faster and trickier it becomes!",
        },
      ],
      features: [
        {
          title: "1. Think Fast, Move Smart",
          content:
            "Pixel Shuffle is more than just a runner it’s a brain teasing shape puzzle combined with reflex based action. With vibrant visuals and smooth transitions, every level tests your reaction speed and puzzle-solving ability.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we’re all about combining fun with mental agility. Pixel Shuffle is designed to boost spatial awareness, pattern recognition, and decision making skills in a fun and colorful environment.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our expert developers at htmlh5games have crafted Pixel Shuffle to offer a fresh twist on the runner genre. With dynamic gameplay, smooth controls, and sharp design, we ensure players stay hooked as they run, shift, and match their way through endless challenges.",
        },
      ],
    },
  },
  {
    id: "policesprinter",
    name: "Police Sprinter",
    img: policesprinter,
    banner: require("../Assets/images/banner/police_sprinter.jpg"),
    description: "Chase criminals & race the streets!",
    gamePath: "/Games/cop_sprinter/index.htm",
    category: "Racing",
    type: "Latest",
    about: {
      heading: "Play Police Sprinter Game Online",
      sections: [
        {
          title: "1. What is Police Sprinter?",
          content:
            "Police Sprinter is an endless running action game developed by htmlh5games. Players take on the role of a policeman sprinting to escape a chasing dog, while avoiding tricky obstacles and swooping birds to survive as long as possible.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Police Sprinter, players run through dynamic environments, dodging barriers, leaping over hurdles, and ducking under obstacles. Quick reflexes and sharp focus are key to scoring high and keeping ahead of the relentless chase.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Police Sprinter, players run through dynamic environments, dodging barriers, leaping over hurdles, and ducking under obstacles. Quick reflexes and sharp focus are key to scoring high and keeping ahead of the relentless chase.",
        },
      ],
      features: [
        {
          title: "1. Dash into Action with htmlh5games",
          content:
            "Experience the thrill of a high speed chase! Test your agility, avoid unexpected dangers, and see how far you can run before getting caught.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team dedicated to bringing exciting and fast paced games to players everywhere. With Police Sprinter, we deliver a fun and challenging running adventure that keeps you coming back for more.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented team designs visually vibrant and engaging games. Their attention to detail ensures Police Sprinter is full of energy, humor, and endless entertainment for players of all ages.",
        },
      ],
    },
  },
  {
    id: "princessdressup",
    name: "Princess Dress Up",
    img: princessdressup,
    banner: require("../Assets/images/banner/princess_dress_up.jpg"),
    description: "Style your princess for every occasion!",
    gamePath: "/Games/princess_dressing/index.html",
    category: "Kids",
    type: "Featured",
    about: {
      heading: "Princess Dress Up Online Free Game",
      sections: [
        {
          title: "1. What is Princess Dress Up?",
          content:
            "Princess Dress Up is a fun fashion makeover game where you style a beautiful princess using fancy gowns, sparkling accessories, and magical hairstyles. Create the look that suits her best and get her ready for every royal moment.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Princess Dress Up, players get access to a royal wardrobe filled with stylish outfits, hairstyles, shoes, jewelry, and more. Mix and match to create the perfect look for the princess and get her ready for the ball, a royal party, or even a magical adventure.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "There are no limits  change from a royal ball gown to a fairy outfit in just seconds. With so many wardrobe choices, every makeover feels special. Kids can express their imagination and enjoy designing endlessly.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Princess Dress Up",
          content:
            "Open the wardrobe and explore a wide range of outfits  from fairy tale dresses to shining tiaras. Try different styles, match colors, and design your princess just the way you imagine Every new look feels like a fresh story.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Tap to change clothes, shoes, and hairstyles",
            "Drag and place accessories on your princess",
            "Mix and match until you find the perfect outfit",
            "Save your final look and play again with new ideas",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Match accessories with the dress theme for a complete style",
            "Try different backgrounds to make the look shine",
            "Experiment with bold and soft colors to see what fits best",
            "Take your time  the most magical styles come with creativity",
          ],
        },
      ],
      features: [
        {
          title: "1. Dress Up Your Way",
          content:
            "Hundreds of styling options give young players freedom to create a princess that truly feels like their own design.",
        },
        {
          title: "2. Simple & Kid-Friendly",
          content:
            "Easy buttons, bright visuals, and smooth controls make the game enjoyable for all ages  especially fashion loving kids.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Designed by our team with attention to detail, safe gameplay, and charming graphics that make every outfit moment magical.",
        },
      ],
    },
  },
  {
    id: "princessfrosty",
    name: "Princess Frosty New Years",
    img: princessfrosty,
    banner: require("../Assets/images/banner/princess_frosty_new_years.jpg"),
    description: "Style your princess for a frosty New Year!",
    gamePath: "/Games/frosty_new_years_fest/index.html",
    category: "Kids",
    type: "Featured",
    about: {
      heading: "Play Princess Frosty New Years Online Free",
      sections: [
        {
          title: "1. What is Frosty New Year's Fest?",
          content:
            "Frosty New Year's Fest is a fun filled holiday celebration game available on htmlh5games. Join two adorable dolls as they prepare for the magical New Year’s Eve party starting with baking delicious cupcakes and getting dressed up in sparkling party outfits!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Frosty New Year's Fest, the excitement begins in the kitchen where you decorate sweet frosty cupcakes with colorful toppings and festive sprinkles. Once the treats are ready, it’s time to dress up both dolls in glamorous New Year fashion choose their dresses, shoes, accessories, and more to make them shine at the party!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Frosty New Year's Fest, the excitement begins in the kitchen where you decorate sweet frosty cupcakes with colorful toppings and festive sprinkles. Once the treats are ready, it’s time to dress up both dolls in glamorous New Year fashion choose their dresses, shoes, accessories, and more to make them shine at the party!",
        },
      ],
      features: [
        {
          title: "1. Bake, Style, and Celebrate",
          content:
            "Frosty New Year's Fest brings together baking fun and fashion creativity in one joyful game. With cheerful music, snowy themes, and sparkly designs, players can enjoy the perfect mix of holiday magic and imagination.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create games that inspire creativity, fun, and seasonal joy. Frosty New Year's Fest is designed to help players explore their styling skills, baking talents, and festive spirit all in one interactive celebration.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "The htmlh5games team has carefully designed Frosty New Year’s Fest to be charming, colorful, and easy to play. With lovely visuals, intuitive controls, and holiday themed excitement, it’s the perfect way for kids to welcome the New Year in style!",
        },
      ],
    },
  },
  {
    id: "redball",
    name: "Red Ball 4",
    img: redball,
    banner: require("../Assets/images/banner/red_ball_4.jpg"),
    description: "Roll, jump & save the world!",
    gamePath: "/Games/ball_adventure/index.htm",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Red Ball 4 Online Free Game",
      sections: [
        {
          title: "1. What is Red Ball 4?",
          content:
            "Red Ball 4 is a lively and challenging platform adventure on htmlh5games, where you roll, bounce, and leap your way through tricky levels to stop the evil black squares from taking over the world.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Guide your brave red ball across dangerous traps. Use precise jumps to dodge spikes, push objects to solve puzzles, and crush the enemy squares along the way. Timing and skill are the keys to rolling your way to victory!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Guide your brave red ball across dangerous traps. Use precise jumps to dodge spikes, push objects to solve puzzles, and crush the enemy squares along the way. Timing and skill are the keys to rolling your way to victory!",
        },
      ],
      features: [
        {
          title: "1. Fun Physics & Rolling Action",
          content:
            "Enjoy classic platformer gameplay with smooth rolling physics and clever level design that keeps every stage exciting. Vibrant cartoon graphics, charming animations, and a brave red hero make every adventure fun and full of personality.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring classic arcade fun to players of all ages. Red Ball 4 combines action, puzzles, and character charm to create an unforgettable rolling adventure.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team designed each obstacle, enemy, and puzzle to challenge your reflexes and creativity making every bounce and roll satisfying.",
        },
      ],
    },
  },
  {
    id: "rescuethefish",
    name: "Rescue The Fish",
    img: rescuethefish,
    banner: require("../Assets/images/banner/rescue_the_fish.jpg"),
    description: "Solve puzzles & save the fish!",
    gamePath: "/Games/aquanaut_rescue/index.htm",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Rescue The Fish Game Online Free",
      sections: [
        {
          title: "1. What is Rescue The Fish?",
          content:
            "Rescue The Fish is an underwater puzzle adventure on htmlh5games, where your mission is to save a brave aquanaut trapped deep in the ocean! Navigate tricky underwater traps, moving barriers, and dangerous sea creatures to guide the aquanaut safely back to the surface.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Pull the right pins, open the right gates, and avoid deadly hazards like spikes, crabs, and swirling currents. Each level challenges your logic and timing: make the wrong move, and the aquanaut might end up in deeper trouble. Think ahead, rescue smartly, and help your hero find freedom!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Pull the right pins, open the right gates, and avoid deadly hazards like spikes, crabs, and swirling currents. Each level challenges your logic and timing: make the wrong move, and the aquanaut might end up in deeper trouble. Think ahead, rescue smartly, and help your hero find freedom!",
        },
      ],
      features: [
        {
          title: "1. Puzzle & Rescue Fun",
          content:
            "Simple controls meet clever puzzles that get trickier as you dive deeper. Cartoon style graphics, cute animations, and charming sea life bring every rescue mission to life.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we design casual games full of creativity and charm. Rescue The Fish offers relaxing yet rewarding gameplay for players of all ages.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted each level to balance fun, strategy, and humor  making every successful rescue feel satisfying.",
        },
      ],
    },
  },
  {
    id: "returnman",
    name: "Return-Man-2",
    img: returnman,
    banner: require("../Assets/images/banner/return_man_2.jpg"),
    description: " Dodge tackles & score epic touchdowns!",
    gamePath: "/Games/slam_dunk_showdown/index.html",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Return-Man-2 Online Free Game",
      sections: [
        {
          title: "1. What is Return Man 2?",
          content:
            "Return Man 2 is an action packed  football game on htmlh5games. In this fast paced sports challenge, players take on the role of a kick returner, dodging defenders to score thrilling touchdowns.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Return Man 2, players must catch the ball and sprint toward the end zone while avoiding tacklers and obstacles. With each advancing level, the game becomes more challenging, testing your reflexes, decision-making, and timing. Power-ups and blockers can be unlocked to gain an edge on the field.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Return Man 2, players must catch the ball and sprint toward the end zone while avoiding tacklers and obstacles. With each advancing level, the game becomes more challenging, testing your reflexes, decision making, and timing. Power ups and blockers can be unlocked to gain an edge on the field.",
        },
      ],
      features: [
        {
          title: "1. Run to Victory",
          content:
            "Return Man 2 provides a realistic football experience with smooth animations and challenging gameplay. Each match is packed with adrenaline as players dodge, weave, and strategize their path to victory.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we believe in combining fun with skill development. Return Man 2 helps players sharpen their hand eye coordination, agility, and tactical thinking while keeping the excitement alive at every turn.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative minds at htmlh5games have worked hard to make Return Man 2 accessible and engaging for sports fans of all ages. With responsive controls, engaging graphics, and intuitive gameplay, we ensure that players enjoy a top tier gaming experience every time they step onto the virtual field.",
        },
      ],
    },
  },
  {
    id: "savethecowboy",
    name: "Save The Cowboy",
    img: savethecowboy,
    banner: require("../Assets/images/banner/save_the_cowboy.jpg"),
    description: "Shoot ropes & save the cowboy!",
    gamePath: "/Games/save_the_cowboy/index.htm",
    category: "Action",
    type: "Trending",
    about: {
      heading: "Play Free Save The Cowboy Game Online ",
      sections: [
        {
          title: "1. What is Save The Cowboy?",
          content:
            "Save The Cowboy is an engaging puzzle and aim game developed by htmlh5games. Players must shoot precisely to cut the rope and rescue a cowboy hanging in danger, testing both skill and strategy.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Save The Cowboy, each level presents the cowboy in a tricky situation. Players need to aim carefully to cut the rope without harming the cowboy, while dealing with obstacles and increasing difficulty as levels progress.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Save The Cowboy, each level presents the cowboy in a tricky situation. Players need to aim carefully to cut the rope without harming the cowboy, while dealing with obstacles and increasing difficulty as levels progress.",
        },
      ],
      features: [
        {
          title: "1. Rescue with Precision with htmlh5games",
          content:
            "Feel the excitement of saving the day! Challenge your aim and timing as you free the cowboy, beat new levels, and unlock tougher puzzles.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team focused on making puzzle and skill based games that are both fun and rewarding. With Save The Cowboy, we combine classic rescue gameplay with modern design for players of all ages.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers ensure smooth gameplay, appealing graphics, and satisfying physics. Their dedication keeps Save The Cowboy challenging, entertaining, and fresh at every level.",
        },
      ],
    },
  },
  {
    id: "magicprincess",
    name: "Magic Princess-Dress Up",
    img: magicprincess,
    banner: require("../Assets/images/banner/magic_princess_dress_up.jpg"),
    description: "Style your princess with magical looks!",
    gamePath: "/Games/princess_dress_up/index.html",
    category: "Kids",
    type: "Trending",
    about: {
      heading: "Magic Princess - Dress Up Online Free Game",
      sections: [
        {
          title: "1. What is Magic Princess – Dress Up?",
          content:
            "Magic Princess – Dress Up is a delightful fashion game on htmlh5games, where you enter a sparkling fantasy world to style and dress up your very own magical princess. Create beautiful looks fit for royal balls, enchanted gardens, or moonlit castle parties!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Choose from gorgeous dresses, elegant shoes, glittering crowns, and magical accessories to craft the perfect princess outfit. Mix and match colors, hairstyles, and gowns to bring your fairy-tale vision to life. Share your creations or keep styling until you find the perfect royal look!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Choose from gorgeous dresses, elegant shoes, glittering crowns, and magical accessories to craft the perfect princess outfit. Mix and match colors, hairstyles, and gowns to bring your fairy tale vision to life. Share your creations or keep styling until you find the perfect royal look!",
        },
      ],
      features: [
        {
          title: "1. Endless Fashion Combinations",
          content:
            "A rich wardrobe of flowing gowns, sparkling jewelry, and charming accessories lets you create countless magical styles. Enjoy dreamy backgrounds, shimmering details, and beautiful animations that bring your princess world to life.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring creativity and imagination together. Magic Princess – Dress Up lets players explore fashion, fantasy, and storytelling all in one magical experience.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted every dress, crown, and sparkling detail with care  making sure every princess feels unique, stylish, and truly magical.",
        },
      ],
    },
  },
  {
    id: "soccerlegends",
    name: "Soccer Legends 2021",
    img: soccerlegends,
    banner: require("../Assets/images/banner/soccer_legends_2021.jpg"),
    description: "Score goals & become a legend!",
    gamePath: "/Games/soccer_sages/index.html",
    category: "Sports",
    type: "Trending",
    about: {
      heading: "Soccer Legends 2021 Online Free Game",
      sections: [
        {
          title: "1. What is Soccer Legends 2021?",
          content:
            "Soccer Legends 2021 is an action packed football game developed by htmlh5games. Players control legendary soccer stars, score spectacular goals, and compete in fast paced matches that test reflexes, strategy, and teamwork.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Soccer Legends 2021, players can pass, dribble, and shoot to outplay their opponents and claim victory. The game features intuitive controls, dynamic animations, and different modes to challenge players of all skill levels.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Soccer Legends 2021, players can pass, dribble, and shoot to outplay their opponents and claim victory. The game features intuitive controls, dynamic animations, and different modes to challenge players of all skill levels.",
        },
      ],
      features: [
        {
          title: "1. Step into the Football Arena with htmlh5games",
          content:
            "Experience the thrill of soccer like never before. Lead your favorite legends to glory, pull off stunning moves, and enjoy exciting matches packed with action and fun!",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a passionate team dedicated to creating sports games that capture the excitement of real matches. With Soccer Legends 2021, we bring the energy of the stadium to your screen.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team carefully crafted every card, shuffle, and animation to feel just right whether you’re a first time player or lifelong fan.",
        },
      ],
    },
  },

  {
    id: "steeringmaster",
    name: "Steering Master",
    img: steeringmaster,
    banner: require("../Assets/images/banner/steering_master.jpg"),
    description: "Steer sharp & master the road!",
    gamePath: "/Games/steering_master/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Steering Master Game Online",
      sections: [
        {
          title: "1. What is Steering Master?",
          content:
            "Steering Master is a fast paced, precision driving arcade game on htmlh5games, where your reflexes and steering skills are put to the ultimate test. Tight corners, narrow roads, and unexpected obstacles stand between you and the finish line!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Take control of your car and steer your way through twisty tracks, sudden turns, and moving barriers. Every level demands sharp timing and smooth control to avoid crashing and keep your run alive. The further you go, the faster and trickier the course becomes perfect for drivers who love a real challenge.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Take control of your car and steer your way through twisty tracks, sudden turns, and moving barriers. Every level demands sharp timing and smooth control to avoid crashing and keep your run alive. The further you go, the faster and trickier the course becomes perfect for drivers who love a real challenge.",
        },
      ],
      features: [
        {
          title: "1. Pure Steering Skill",
          content:
            "No shortcuts just precise control and quick thinking as you drift, dodge, and turn your way through every twist.Face an ever changing set of tracks with shifting lanes, moving blocks, and sharp bends that keep you alert.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create arcade experiences that reward skill and focus. Steering Master brings classic driving fun into an endlessly replayable, modern package.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team crafted every curve and obstacle to challenge your reflexes while keeping gameplay smooth, satisfying, and endlessly fun.",
        },
      ],
    },
  },

  {
    id: "shushichef",
    name: "Sushi Chef",
    img: shushichef,
    banner: require("../Assets/images/banner/sushi_chef.jpg"),
    description: "Roll sushi & delight your guests!",
    gamePath: "/Games/adorable_sushi_sizzle/index.html",
    category: "Kids",
    type: "trending",
    about: {
      heading: "Sushi Chef Online Free Game",
      sections: [
        {
          title: "1. What is Sushi Chef?",
          content:
            "Sushi Chef is a creative cooking game on htmlh5games, where you step behind the counter to craft beautiful sushi rolls  including special heart shaped creations! Mix flavors, roll carefully, and finish each dish with a perfect garnish.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Choose fresh ingredients, slice them neatly, and roll your sushi into classic shapes or sweet heart designs. Add colorful toppings, sauces, and decorative garnishes to turn every plate into a masterpiece. Impress your virtual guests and unlock new ingredients and recipes as you go.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Choose fresh ingredients, slice them neatly, and roll your sushi into classic shapes or sweet heart designs. Add colorful toppings, sauces, and decorative garnishes to turn every plate into a masterpiece. Impress your virtual guests and unlock new ingredients and recipes as you go.",
        },
      ],
      features: [
        {
          title: "1. Creative Sushi Making",
          content:
            "Shape and design rolls exactly how you like from classic circles to playful hearts. Top your sushi with sauces, seeds, and vibrant decorations to make every dish stand out. Enjoy calm, satisfying gameplay perfect for quick breaks or longer creative sessions.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring food games to life with charm and detail. Sushi Chef is all about creativity, patience, and a love for beautiful food.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers and artists carefully designed fresh ingredients, elegant heart shapes, and realistic garnishes to make every plate look delicious.",
        },
      ],
    },
  },
  {
    id: "tailtrash",
    name: "Tail Thrash",
    img: tailtrash,
    banner: require("../Assets/images/banner/tail_thrash.jpg"),
    description: "Swing your tail & smash obstacles!",
    gamePath: "/Games/tail_thrash/index.html",
    category: "Adventure",
    type: "Latest",
    about: {
      heading: "Play Tail Thrash Game Online Free",
      sections: [
        {
          title: "1. What is Tail Thrash?",
          content:
            "Tail Thrash is a fast and energetic arcade game where you control a creature with a swinging tail that destroys anything in the way. Keep moving, react quickly, and smash obstacles before they slow you down.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Swing your tail and carve a way forward. The faster you move, the wilder your tail swings but watch out! One wrong move and it’s game over. Can you master the art of the thrash and set a high score?",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tail Thrash delivers nonstop action  no pauses, no time to think twice. As the game speeds up, the screen fills with targets and challenges. Every run brings a new chance to beat your record and feel the thrill of perfect tail swings.",
        },
      ],

      extraContent: [
        {
          title: "🎮 Game: Tail Thrash",
          content:
            "Speed up, swing your tail, and break through every barrier that appears ahead. The movement gets wilder the faster you go  each swipe helps clear the path, but one mistake can end the run. Stay sharp and aim for your best score",
        },
        {
          title: "❓ How to Play",
          list: [
            "Move left or right to steer your creature",
            "Use the tail swings to break obstacles",
            "Avoid dangerous traps and keep your flow steady",
            "Go as far as possible to earn a higher score",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Focus on timing  hit obstacles right before impact",
            "Keep a smooth rhythm when the speed increases",
            "Watch out for traps placed near breakable objects",
            "Practice runs improve quick reactions over time",
          ],
        },
      ],

      features: [
        {
          title: "1. Smash & Survive",
          content:
            "Dynamic animations and satisfying hits make every break exciting while increasing difficulty keeps players alert.",
        },
        {
          title: "2. Quick Fun for Everyone",
          content:
            "Easy to learn and enjoyable in short bursts  great for players who love fast arcade challenges.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed Tail Thrash to be smooth, addictive, and endlessly replayable combining simple mechanics with challenging gameplay to keep you coming back for one more thrash.",
        },
      ],
    },
  },
  {
    id: "targettrimph",
    name: "Target Triumph",
    img: targettrimph,
    banner: require("../Assets/images/banner/target_triumph.jpg"),
    description: "Hit targets & claim triumph!",
    gamePath: "/Games/target_triumph/index.html",
    category: "Sports",
    type: "Featured",
    about: {
      heading: "Play Free Target Triumph Game Online",
      sections: [
        {
          title: "1. What is Target Triumph?",
          content:
            "Target Triumph is an exciting aim and shoot challenge on htmlh5games, where your precision and timing decide every victory! Hit moving targets, smash tricky bullseyes, and prove your skills across dozens of fast paced levels.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap, drag, and release to launch your shots. Some targets spin, some slide, and others pop up unexpectedly  making every level a fresh test of accuracy. Master perfect shots, chain combos for higher scores, and unlock new stages and target designs as you play.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap, drag, and release to launch your shots. Some targets spin, some slide, and others pop up unexpectedly  making every level a fresh test of accuracy. Master perfect shots, chain combos for higher scores, and unlock new stages and target designs as you play.",
        },
      ],
      features: [
        {
          title: "1. Quick, Satisfying Action",
          content:
            "Simple controls make it easy to start, but only sharp aim and perfect timing will help you triumph. Face spinning boards, bouncing targets, and shifting patterns that keep gameplay unpredictable and fun.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love turning classic skill games into modern, engaging challenges. Target Triumph blends arcade fun with rewarding precision.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed crisp visuals, smooth shooting mechanics, and creative target layouts to keep every shot exciting.",
        },
      ],
    },
  },

  {
    id: "teris",
    name: "Tetris",
    img: teris,
    banner: require("../Assets/images/banner/tetris.jpg"),
    description: "Rotate, drop & clear rows!",
    gamePath: "/Games/classic_puzzle_game/index.html",
    category: "Adventure",
    type: "Trending",
    about: {
      heading: "Play Tetris Online Free",
      sections: [
        {
          title: "1. What is Tetris Game?",
          content:
            "Tetris Game is a timeless puzzle classic brought to you by htmlh5games. Players rotate and arrange falling blocks to clear complete lines, boosting spatial awareness, quick thinking, and pattern recognition.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Tetris Game, players must think fast to place blocks strategically, avoiding gaps and preventing the stack from reaching the top. The game features colorful visuals, smooth controls, and various difficulty levels to challenge beginners and experts alike.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Tetris Game, players must think fast to place blocks strategically, avoiding gaps and preventing the stack from reaching the top. The game features colorful visuals, smooth controls, and various difficulty levels to challenge beginners and experts alike.",
        },
      ],
      features: [
        {
          title: "1. Discover the Timeless Puzzle World with htmlh5games",
          content:
            "Dive into the world of falling blocks where every move counts. Enjoy a blend of relaxing yet mentally stimulating gameplay that never goes out of style!",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team committed to delivering classic puzzle experiences to modern players. With Tetris Game, we aim to keep the magic of this iconic game alive for puzzle lovers everywhere.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers recreate the classic Tetris experience with fresh graphics and intuitive controls. Their dedication ensures that every session feels rewarding, entertaining, and endlessly replayable.",
        },
      ],
    },
  },
  {
    id: "thespikecross",
    name: "The Spike Cross",
    img: thespikecross,
    banner: require("../Assets/images/banner/the_spike_cross.jpg"),
    description: "Time your jumps & cross the spikes!",
    gamePath: "/Games/spikes_master/index.html",
    category: "Action",
    type: "Latest",
    about: {
      heading: "The Spike Cross Online Free Game",
      sections: [
        {
          title: "1. What is The Spike Cross?",
          content:
            "The Spike Cross is a thrilling arcade challenge on htmlh5games, where players must guide their character through a deadly maze of spinning spikes, swinging blades, and moving traps. One wrong step and it’s game over!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Tap, jump, or dash at just the right moment to cross dangerous paths filled with spikes and shifting obstacles. Each level gets faster and more unpredictable, testing your reflexes, timing, and nerves. The goal? See how far you can go without getting caught!",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Tap, jump, or dash at just the right moment to cross dangerous paths filled with spikes and shifting obstacles. Each level gets faster and more unpredictable, testing your reflexes, timing, and nerves. The goal? See how far you can go without getting caught!",
        },
      ],
      features: [
        {
          title: "1. Quick & Addictive Action",
          content:
            "Easy to learn, impossible to put down! Perfect for short bursts of play or intense high score runs. Minimalist yet striking graphics paired with tight, responsive controls make every near miss feel rewarding.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we create fast, fun, and challenging arcade experiences. The Spike Cross keeps players hooked with pure skill based gameplay that rewards practice and precision.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team designed every trap, spike, and pattern to keep you on the edge of your seat. With smooth animations and increasingly tricky levels, every attempt feels fresh and exciting.",
        },
      ],
    },
  },
  {
    id: "tinyfishing",
    name: "Tiny Fishing",
    img: tinyfishing,
    banner: require("../Assets/images/banner/tiny_fishing.jpg"),
    description: "Cast your line & catch tiny treasures!",
    gamePath: "/Games/lure_legends/index.html",
    category: "Racing",
    type: "Trending",
    about: {
      heading: "Play Tiny Fishing Game Online Free",
      sections: [
        {
          title: "1. What is Tiny Fishing?",
          content:
            "Tiny Fishing is a relaxing fishing game where you drop your line into the sea and catch as many fish as you can From small swimmers to rare deep sea treasures, every cast brings something exciting. Tap, reel, and enjoy the peaceful underwater fun.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Tiny Fishing, players drop their fishing line and try to catch as many fish as possible before pulling it back up. The deeper you go, the more rare and valuable the fish become! Earn coins with every catch, upgrade your line depth, and improve your hook to collect more fish with each trip.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Every cast feels satisfying  more fish, more coins, and more upgrades waiting ahead. It’s the perfect game to play anytime when you want calm, rewarding fun. Watch your fishing skills grow with each dive into the ocean.",
        },
      ],
      extraContent: [
        {
          title: "🎮 Game: Tiny Fishing",
          content:
            "Cast your hook deep below the waves  the deeper it goes, the more valuable the catch Bring up colorful fish, earn coins, and upgrade your fishing gear to dive even further. Each trip helps you discover new species and bigger rewards.",
        },
        {
          title: "❓ How to Play",
          list: [
            "Tap to cast your fishing line",
            "Move the hook left and right to catch fish",
            "Earn coins with every successful catch",
            "Upgrade depth and hooks to collect more fish next time",
          ],
        },
        {
          title: "💡 Tips",
          list: [
            "Focus on rare fish deeper in the water for higher coins",
            "Upgrade hook capacity quickly to grab multiple fish at once",
            "Avoid empty spots  keep your line moving to catch more",
            "Deeper levels unlock surprises",
          ],
        },
      ],
      features: [
        {
          title: "1. Easy, Calm & Addictive",
          content:
            "Smooth controls and satisfying catches make it great for quick breaks or long relaxing sessions.",
        },
        {
          title: "2. Fun for All Ages",
          content:
            "No rush, no stress  just simple fishing joy with a colorful ocean full of discoveries.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our team at htmlh5games carefully crafted Tiny Fishing to be lightweight, smooth, and endlessly replayable. Whether you're playing for a few minutes or trying to reach the deepest ocean levels, the fun never stops.",
        },
      ],
    },
  },
  {
    id: "trafficrush",
    name: "Traffic Rush",
    img: trafficrush,
    banner: require("../Assets/images/banner/traffic_rush.jpg"),
    description: "Cross roads & beat the traffic!",
    gamePath: "/Games/traffic_tycoon_triumph/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Traffic Rush Online Free Game",
      sections: [
        {
          title: "1. What is Traffic Rush?",
          content:
            "Traffic Rush is a smart traffic management simulation game developed by htmlh5games. Players strategically control traffic lights and intersections to keep traffic flowing smoothly and avoid congestion in a bustling city.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In Traffic Rush, players tap and time traffic lights to guide vehicles safely across intersections. Quick decisions and sharp observation are key to preventing crashes and ensuring the city runs efficiently.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In Traffic Rush, players tap and time traffic lights to guide vehicles safely across intersections. Quick decisions and sharp observation are key to preventing crashes and ensuring the city runs efficiently.",
        },
      ],
      features: [
        {
          title: "1. Master the City Streets with htmlh5games",
          content:
            "Step into the role of a traffic controller! Keep traffic moving, prevent jams, and experience the satisfaction of running a perfectly timed urban intersection.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team dedicated to crafting simulation and strategy games that challenge and entertain. With Traffic Rush, we bring the excitement of urban traffic control to your screen.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented team designs visually appealing and responsive games. Their hard work ensures Traffic Rush feels realistic, challenging, and rewarding to play every time.",
        },
      ],
    },
  },

  {
    id: "whiskerwood",
    name: "Whiskerwood",
    img: whiskerwood,
    banner: require("../Assets/images/banner/whiskerwood.jpg"),
    description: "Explore forests & help furry friends!",
    gamePath: "/Games/rolling_whiskers/index.html",
    category: "Racing",
    type: "Featured",
    about: {
      heading: "Play Free Whiskerwood Game Online",
      sections: [
        {
          title: "1. What is Whiskerwood Game?",
          content:
            "Whiskerwood Game is a charming puzzle adventure game on htmlh5games, where you guide the magical Whisker Ball through levels filled with clever puzzles, hidden stars, and locked doors waiting to be opened!",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Use intuitive touch controls to roll the Whisker Ball across each level. Collect shining stars and key that unlocks the door to the next stage. Every puzzle is carefully designed to blend relaxing gameplay with satisfying problem-solving perfect for quick sessions or long, cozy play.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Use intuitive touch controls to roll the Whisker Ball across each level. Collect shining stars and key that unlocks the door to the next stage. Every puzzle is carefully designed to blend relaxing gameplay with satisfying problem solving perfect for quick sessions or long, cozy play.",
        },
      ],
      features: [
        {
          title: "1. Touch & Roll Controls",
          content:
            "Smooth, intuitive swipes let anyone pick up and play easy to learn, rewarding to master. Challenge yourself to grab every star and unlock each door, discovering new surprises along the way. Each level of Whiskerwood feels unique, blending gentle challenge with a relaxing forest atmosphere.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we love games that mix puzzle solving with charm and simplicity. Whiskerwood is all about thoughtful gameplay, gentle exploration, and a touch of woodland magic.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our developers and artists worked together to create peaceful forest settings, clever level designs, and a playful Whisker Ball that feels alive.",
        },
      ],
    },
  },
  {
    id: "worldtour",
    name: "World Tour Game",
    img: worldtour,
    banner: require("../Assets/images/banner/world_tour_game.jpg"),
    description: "Travel, play & collect souvenirs!",
    gamePath: "/Games/tiny_world_traveler/index.html",
    category: "Adventure",
    type: "Featured",
    about: {
      heading: "World Tour Online Free Game ",
      sections: [
        {
          title: "1. What is World Tour Game?",
          content:
            "World Tour Game is a unique simulation and time management game developed by htmlh5games. Players step into the role of a hostess, helping travelers check in, stamping passports for different visas, and preparing for exciting flights around the world.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "In World Tour Game, players guide the hostess through her daily routine getting ready, assisting travelers, and ensuring smooth boarding. The game features charming graphics, real-world destinations, and fun challenges that make every virtual flight an adventure.",
        // },
      ],
      gameplay: [
        {
          title: "2. Gameplay",
          content:
            "In World Tour Game, players guide the hostess through her daily routine getting ready, assisting travelers, and ensuring smooth boarding. The game features charming graphics, real world destinations, and fun challenges that make every virtual flight an adventure",
        },
      ],
      features: [
        {
          title: "1. Explore the World with htmlh5games",
          content:
            "Travel across continents without leaving your screen! Experience the thrill of airport life, meet travelers from around the globe, and collect stamps from countless countries.",
        },
        {
          title: "2. Who Are We?",
          content:
            "htmlh5games is a creative team passionate about designing immersive simulation games. With World Tour Game, we invite players to discover the joy and challenges of working in international travel.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "At htmlh5games, our talented developers and designers craft visually captivating and engaging experiences. Their dedication brings to life an authentic yet playful airport world that keeps players entertained on every journey.",
        },
      ],
    },
  },
  // {
  //   id: "MarbleBlast",
  //   name: "Zuma",
  //   img: zuma,
  //   banner: require("../Assets/images/banner/zuma.jpg"),
  //   description: "Shoot & match to clear the path!",
  //   gamePath: "/Games/gem_blast/index.html",
  //   category: "Action",
  //   type: "Featured",
  //   about: {
  //     heading: "Play Marble Blast Game Online Free",
  //     sections: [
  //       {
  //         title: "1. What is Marble Blast?",
  //         content:
  //           "Marble Blast is a thrilling marble shooter puzzle game that will test your reflexes, focus, and aim Step into mysterious temples and ancient ruins where colorful marbles roll along winding paths  and your goal is to stop them before they reach the end. Match colors, blast chains, and trigger powerful combos to win every stage.",
  //       },
  //       // {
  //       //   title: "2. Gameplay",
  //       //   content:
  //       //     "Shoot colored marbles from your stone frog into the moving chain, matching three or more to make them disappear. Create combos, chain reactions, and power-ups to clear levels faster and score big points. Every stage brings new patterns, faster speeds, and trickier paths!",
  //       // },
  //     ],
  //      extraContent: [
  //       {
  //         title: "🎮 Game: Marble Blast",
  //         content:
  //           "Control your marble shooter, match three or more of the same color, and blast the moving chain before it escapes. Each level brings faster paths, unique obstacles, and powerful boosters that keep the excitement going.",
  //       },
  //       {
  //         title: "❓ How to Play",
  //         list: [
  //           "Tap to shoot and match marbles of the same color",
  //           "Create combos to trigger power ups and score big",
  //           "Prevent the marble chain from reaching the end",
  //           "Clear all marbles to complete the level",
  //         ],
  //       },
  //       {
  //         title: "💡 Tips",
  //         list: [
  //           "Focus on creating long combos for higher points",
  //           "Aim ahead of the moving chain to time shots perfectly",
  //           "Use special marbles (bombs, slowdowns, color swaps) wisely",
  //           "Stay calm as speed increases  accuracy matters most.",
  //         ],
  //       },
  //     ],
  //     gameplay: [
  //       {
  //         title: "2. Gameplay",
  //         content:
  //           "Marble Blast mixes reflex and strategy in a fast paced puzzle challenge. Each stage feels fresh with new layouts, vibrant visuals, and exciting power ups. It’s perfect for players who love colorful action and satisfying chain reactions.",
  //       },
  //     ],
  //     features: [
  //       {
  //         title: "1. Addictive Marble Shooting Fun",
  //         content:
  //           "Easy to play but hard to put down  match colors, blast chains, and enjoy hours of puzzle excitement.",
  //       },
  //       {
  //         title: "2. Beautiful & Relaxing Design",
  //         content:
  //           "Set in glowing temples and mystical runs, each level features bright visuals, smooth animations, and calming sound effects.",
  //       },
  //       {
  //         title: "3. Meet Our Talented Developers and Designers",
  //         content:
  //           "Our team designed every level for smooth controls, balanced challenges, and endless replay value  making Marble Blast a perfect mix of fun and focus.",
  //       },
  //     ],
  //   },
  // },
   {
    id: "zuma",
    name: "Zuma",
    img: zuma,
    banner: require("../Assets/images/banner/zuma.jpg"),
    description: "Shoot & match to clear the path!",
    gamePath: "/Games/gem_blast/index.html",
    category: "Action",
    type:"Featured",
    about: {
      heading: "Play Zuma Game Online Free",
      sections: [
        {
          title: "1. What is Zuma?",
          content:
            "Zuma is the timeless marble shooter puzzle game now on htmlh5games! Enter ancient temples and mystical ruins where your quick reflexes and sharp aim are the only way to stop colorful rolling balls before they reach the end.",
        },
        // {
        //   title: "2. Gameplay",
        //   content:
        //     "Shoot colored marbles from your stone frog into the moving chain, matching three or more to make them disappear. Create combos, chain reactions, and power-ups to clear levels faster and score big points. Every stage brings new patterns, faster speeds, and trickier paths!",
        // },
      ],
       gameplay: [
        {
          title: "2. Gameplay",
          content:
            "Shoot colored marbles from your stone frog into the moving chain, matching three or more to make them disappear. Create combos, chain reactions, and power ups to clear levels faster and score big points. Every stage brings new patterns, faster speeds, and trickier paths!",
        },
      ],
      features: [
        {
          title: "1. Fast & Addictive Puzzle Action",
          content:
            "Simple controls meet challenging gameplay that keeps you coming back for just one more round. Play through beautifully crafted levels set in temples, jungles, and ruins filled with stone carvings and glowing marbles.",
        },
        {
          title: "2. Who Are We?",
          content:
            "At htmlh5games, we bring classic arcade and puzzle games to new generations of players. Zuma combines strategy, reflexes, and satisfying visuals into one timeless experience.",
        },
        {
          title: "3. Meet Our Talented Developers and Designers",
          content:
            "Our creative team faithfully recreated the smooth shooting, hypnotic rolling chains, and rewarding combos that made Zuma an all time favorite.",
        },
      ],
    },
  },
];



export const blogData = [
  // {
  //   id: 1,
  //   name:"Angry Birds",
  //   slug: "Angry-birds",
  //   title: "Launch, Aim, and Conquer in This Addictive Physics Puzzle!",
  //   shortDesc:"Experience the thrill of physics based puzzle gameplay where strategy meets fun! Launch colorful birds from your slingshot, aim for the perfect shot, and watch as structures collapse in spectacular fashion. With hundreds of challenging levels, adorable characters, and satisfying destruction mechanics, this addictive game keeps you entertained for hours. Master different bird types, unlock special abilities, and achieve three-star ratings on every level. Perfect for puzzle lovers of all ages.",
  //   banner: require("../Assets/images/banner/angry_birds.jpg"),

  //   screenshots: [
  //     { src: require("../Assets/images/crazy-birds2.png"),  },
  //     { src: require("../Assets/images/crazy-birds.png"),  },
  //   ],

  //   welcomeTitle: "Welcome to Crazy Birds Attack!",
  //   intro: [
  //     "Get ready for an exciting adventure with Crazy Birds Attack, the ultimate physics-based puzzle game that will keep you entertained for hours! If you love strategic gameplay mixed with fun and colorful graphics, this game is perfect for you. Launch your feathered friends using a slingshot and take down those mischievous green monsters who have stolen your precious eggs.",
  //     "Every level brings new challenges and obstacles that require clever thinking and precise aiming. The game features stunning environments, from peaceful forests to mysterious towers, each designed to test your skills. Whether you're a casual gamer looking for some fun or a puzzle enthusiast seeking a challenge, Crazy Birds Attack offers something special for everyone.",
  //     "With intuitive controls and engaging gameplay, you'll find yourself coming back again and again to beat your high scores and unlock new levels. The satisfaction of watching structures collapse and enemies tumble is simply unmatched."
  //   ],

  //   howToPlayTitle: "How to Play Crazy Birds Attack",
  //   howToPlay: [
  //     "Playing Crazy Birds Attack is easy to learn but challenging to master. Simply pull back on the slingshot, aim at your target, and release to launch your bird. The goal is to defeat all the green monsters on each level using as few birds as possible.",
  //     "Each level is designed like a puzzle where you need to figure out the best angle and power to maximize destruction. Some structures are built with wood, others with stone, and you'll need to identify weak points to bring everything crashing down efficiently.",
  //     "As you progress through the game, you'll encounter different types of birds, each with unique abilities. Some birds can split into multiple birds mid-flight, while others have special powers to smash through tough obstacles. Learning when to use each bird type is key to mastering the game."
  //   ],

  //   featuresTitle: "Amazing Features",
  //   features: [
  //     {
  //       title: "🎯 Realistic Physics Engine",
  //       desc: "Experience authentic gravity and collision mechanics that make every launch feel satisfying. Watch as structures realistically tumble and crash based on real physics principles."
  //     },
  //     {
  //       title: "🌟 Multiple Challenging Levels",
  //       desc: "Play through dozens of carefully crafted levels, each with unique layouts and increasing difficulty. Every level offers a new puzzle to solve and challenges to overcome."
  //     },
  //     {
  //       title: "🎨 Beautiful Graphics & Smooth Animation",
  //       desc: "Enjoy vibrant, colorful visuals with charming character designs and detailed environments. The game features smooth animations and eye-catching effects that bring the action to life."
  //     },
  //     {
  //       title: "🏆 Score System & Achievements",
  //       desc: "Compete for the highest scores and unlock achievements as you progress. Challenge yourself to complete levels with perfect three star ratings on every stage."
  //     },
  //     {
  //       title: "🎮 Easy Controls",
  //       desc: "Simple and intuitive slingshot mechanics make the game accessible to players of all ages. Just drag, aim, and release  it's that easy to start playing and having fun."
  //     }
  //   ],

  //   tipsTitle: "Pro Tips for Success",
  //   tipsub:"Master These Strategies:",
  //   tips: [
  //     "🎯 Always aim for weak points in structures, like the base or connecting joints, to cause maximum damage with minimum birds.",
  //     "🎯 Take your time to study each level before making your first shot. Understanding the layout is half the battle.",
  //     "🎯 Don't waste your special birds on easy targets. Save them for tough obstacles that regular birds can't handle.",
  //     "🎯 Pay attention to the materials. Stone structures require more force, while wooden ones can be destroyed more easily.",
  //     "🎯 Sometimes an indirect approach works better. Try bouncing birds off surfaces or hitting objects to create chain reactions.",
  //     "🎯 Replay levels to improve your scores. You might discover new strategies that earn you those precious three stars."
  //   ],

  //   loveTitle: "Why You'll Love Crazy Birds Attack",
  //   loveDesc: [
  //     "Crazy Birds Attack combines the perfect balance of strategy, skill, and pure fun. Unlike many puzzle games that can feel repetitive, each level in this game presents unique challenges that keep the gameplay fresh and exciting. The colorful characters are full of personality, and watching the dramatic destruction unfold never gets old.",
  //     "The game is designed to be enjoyed in short bursts or longer gaming sessions, making it perfect for any schedule. Whether you have five minutes waiting for the bus or want to spend an evening conquering multiple worlds, Crazy Birds Attack adapts to your playstyle. The difficulty curve is well balanced, starting gentle to help new players learn the mechanics before gradually introducing more complex puzzles.",
  //     "Best of all, the game is completely free to play! You can enjoy all the core features without spending a penny. The optional ads for extra lives are never intrusive, and the game respects your time and choice as a player."
  //   ],

  //   perfectForTitle: "Perfect For All Players",
  //   perfectFor: [
  //     "Crazy Birds Attack appeals to a wide range of players. Kids love the cute characters and simple controls, while adults appreciate the strategic depth and physics based challenges. It's a great game for families to enjoy together, as parents can help younger children with tricky levels while older kids can compete for high scores.",
  //     "The game also serves as an excellent stress reliever. There's something incredibly satisfying about launching birds and watching elaborate structures collapse. After a long day, nothing beats spending a few minutes causing some harmless digital chaos and achieving those three star ratings."
  //   ]
  // },
  {
    id: 1,
    name:"Angry Birds",
    slug: "Angry-birds",
    title: "Launch, Aim, and Smash Your Way Through Fun!",
    shortDesc:"Experience the thrill of physics based puzzle gameplay where strategy meets fun! Launch colorful birds from your slingshot, aim for the perfect shot, and watch as structures collapse in spectacular fashion. With hundreds of challenging levels, adorable characters, and satisfying destruction mechanics, this addictive game keeps you entertained for hours. Master different bird types, unlock special abilities, and achieve three star ratings on every level. Perfect for puzzle lovers of all ages.",
    banner: require("../Assets/images/banner/angry_birds.jpg"),

    screenshots: [
      { src: require("../Assets/images/crazy-birds2.png"),  },
      { src: require("../Assets/images/crazy-birds.png"),  },
    ],

    welcomeTitle: "Welcome to Angry Birds",
    intro: [
      "Get ready to experience one of the most iconic and addictive physics based puzzle games ever created  Angry Birds! Step into a colorful world where you launch a team of determined birds using a slingshot to defeat the sneaky green pigs who stole your precious eggs.",
      "Every level introduces new structures, clever obstacles, and pig fortresses that require strategy, accuracy, and perfect timing. From wooden barricades to stone towers, each layout is designed to test your ability to aim, think, and destroy. Whether you're a casual gamer or a puzzle loving pro, Angry Birds offers endless fun and excitement for all ages.",
      "With captivating visuals, smooth gameplay, and satisfying destruction, this game will keep you hooked as you unlock new birds, abilities, and challenging stages. Watching pig towers collapse and explode after the perfect shot is pure gaming satisfaction!"
    ],

    howToPlayTitle: "How to Play Angry Birds",
    howToPlay: [
      "Playing Angry Birds is simple yet incredibly challenging to master. Pull back on the slingshot, adjust the angle, aim carefully, and release to launch your bird toward the pigs’ structures.",
      "Each level works like a puzzle  you must figure out where to hit to create maximum destruction. Structures are made of different materials like wood, glass, and stone, each requiring different force. Identify weak spots, break supports, and let gravity do the rest!",
      // "As you progress through the game, you'll encounter different types of birds, each with unique abilities. Some birds can split into multiple birds mid-flight, while others have special powers to smash through tough obstacles. Learning when to use each bird type is key to mastering the game."
    ],

    featuresTitle: "Amazing Features",
    features: [
      {
        title: "🎯 Realistic Physics Engine",
        desc: "Enjoy real world gravity, momentum, and collision effects that make every hit satisfying. Watch pig fortresses crumble realistically as you land the perfect shot."
      },
      {
        title: "🌟 Hundreds of Challenging Levels",
        desc: "Play through multiple worlds filled with unique layouts, clever pig defenses, and increasing difficulty. No two levels feel the same!"
      },
      {
        title: "🎨 Beautiful Graphics & Fun Animation",
        desc: "The game features bright colors, adorable characters, and smooth animations that bring every launch and explosion to life."
      },
      {
        title: "🏆 Score System & Star Ratings",
        desc: "Aim for the highest possible score and earn up to three stars on each level based on your accuracy and number of birds used."
      },
      {
        title: "🎮 Simple Yet Addictive Controls",
        desc: "Drag, aim, release  that’s all you need! The game is easy for beginners yet deep enough to challenge experienced players."
      }
    ],

    tipsTitle: "Pro Tips for Success",
    tipsub:"Master these strategies to become a true Angry Birds champion:",
    tips: [
      "🎯 Aim for structural weaknesses like wooden joints, glass sections, or the base of towers to collapse the entire structure.",
      "🎯 Study the level before shooting. Understanding pig placement and material types saves birds and boosts your score.",
      "🎯 Use special birds wisely. Don’t waste explosive or splitting birds on simple targets.",
      "🎯 Use creative shots! Try bouncing birds, hitting from odd angles, or using chain reactions for massive destruction.",
      "🎯 Replay levels to improve your scores and earn those perfect three star ratings.",
    ],

    loveTitle: "Why You'll Love Angry Birds",
    loveDesc: [
      "Angry Birds delivers the perfect blend of strategy, fun, and chaos. With unique bird abilities, clever level design, and satisfying destruction effects, the game never feels repetitive. Every level brings something new new challenges, new structures, and new puzzles to solve.",
      "The game is perfect for short casual sessions or long binge worthy playtimes. Whether you're on a break or relaxing at home, launching birds and toppling pig fortresses is always entertaining.",
      "Best of all, Angry Birds is completely free to play, with optional bonuses that never feel intrusive. Play at your own pace, challenge yourself, and enjoy the thrill of smashing pigs!"
    ],

    perfectForTitle: "Perfect For All Players",
    perfectFor: [
      "Angry Birds appeals to players of all ages. Kids love the cute characters and fun visuals, while adults enjoy the strategy, angles, and puzzle mechanics. It’s also a great game for families  take turns solving levels, compete for high scores, or help each other out.",
      "The game is also amazing for stress relief. After a long day, launching birds and watching pig structures explode is truly satisfying!"
    ]
  },
  
  // {
  //  id: 2,
  //   name: "Subway Surfers",
  //   slug: "Subway-surfers",
  //   shortDesc:"Jump into the most exciting subway escape adventure ever created. Dash through busy train tracks, dodge oncoming trains, and collect coins while running from the inspector. With simple swipe controls and endless running action, every second counts in this heart pounding chase. Navigate through vibrant metro stations, unlock awesome characters, and use powerful boosters to survive longer. Experience smooth gameplay with stunning graphics that bring the subway world to life.",
  //   title: "Escape the Inspector! Run Through the Subway Tracks!",
  //   banner: require("../Assets/images/banner/subway_surfers.jpg"),

  //   screenshots: [
  //     { src: require("../Assets/images/train-runner.png"), },
  //     { src: require("../Assets/images/train-runner2.png"), },
  //   ],

  //   welcomeTitle: "Welcome to Train Runner!",
  //   intro: [
  //     "Get ready for the most thrilling subway escape adventure you've ever experienced! Train Runner is an action packed endless runner game that puts you in the shoes of a daring runner sprinting through busy train tracks, dodging oncoming trains, and jumping over obstacles while collecting coins and power ups. This isn't just another running game  it's a heart pounding chase that will test your reflexes and keep you coming back for more.",
  //     "In Train Runner, you're constantly on the move through vibrant subway stations, railway tracks, and urban environments. The game captures the excitement and intensity of running through a busy metro system where every second counts. One wrong move and you'll crash into a train or barrier, ending your run. But with quick reflexes and smart decisions, you can run endlessly while racking up impressive scores.",
  //     "What makes Train Runner special is its perfect blend of accessibility and challenge. Anyone can pick up the game and start playing within seconds thanks to intuitive swipe controls. However, mastering the game requires practice, strategy, and lightning-fast reactions. The game gets progressively faster and more challenging the longer you survive, ensuring that even experienced players always face exciting new challenges."
  //   ],

  //   howToPlayTitle: "🔥 Experience the Ultimate Subway Chase",
  //   howToPlay: [
  //     "Train Runner delivers an authentic endless running experience through detailed subway environments. You'll dash between train tracks, slide under barriers, leap over obstacles, and dodge incoming trains while an inspector chases you relentlessly. The game features smooth animations and responsive controls that make every swipe feel natural and satisfying.",
  //     "Every run is unique thanks to randomly generated obstacles and dynamic train patterns. You'll never play the same game twice, which keeps the experience fresh and exciting. The environments constantly change as you progress, taking you through different subway stations, tunnels, and outdoor railway sections. Each location brings new visual elements and challenges to overcome.",
  //     "The game automatically increases speed as you advance, creating an intense challenge that pushes your reflexes to the limit. Collecting coins allows you to unlock new characters, upgrade power ups, and customize your runner. With dozens of characters to unlock and endless gameplay possibilities, Train Runner offers incredible replay value."
  //   ],

  //   featuresTitle: "✨ Amazing Game Features",
  //   features: [
  //     {
  //       title: "🚇 Run Through Subway Tracks",
  //       desc: "Navigate through realistic subway environments filled with trains, platforms, and urban landscapes. Experience the thrill of running between active railway tracks where trains pass by at high speeds."
  //     },
  //     {
  //       title: "🎮 Simple Swipe Controls",
  //       desc: "Master the game instantly with easy swipe gestures. Swipe up to jump, down to slide, and left or right to switch lanes. The controls are responsive and intuitive for players of all skill levels."
  //     },
  //     {
  //       title: "🏃 Endless Running",
  //       desc: "Experience true endless gameplay where the only limit is your skill and reflexes. The game continues as long as you can survive, with increasing speed and difficulty to keep you challenged."
  //     },
  //     {
  //       title: "💰 Coins & Rewards",
  //       desc: "Gather coins scattered throughout the tracks to unlock new characters and upgrades. The more you play, the more rewards you earn to enhance your gaming experience."
  //     },
  //     {
  //       title: "⚡ Epic Power-Ups",
  //       desc: "Discover amazing power-ups that give you temporary superpowers. Activate jetpacks, hoverboards, shields, and more to help you survive longer and score higher."
  //     },
  //   ],

  //   tipsTitle: "Pro Tips for Maximum Distance",
  //   tipsub:"",
  //   tips: [
  //     "⚡ Always stay alert and look ahead at what's coming. Don't focus only on your character  watch for trains and obstacles in the distance to react faster.",
  //     "⚡ Use the middle lane as your default position. This gives you maximum flexibility to dodge left or right when obstacles appear suddenly.",
  //     "⚡ Time your jumps carefully over barriers. Jumping too early or too late can cause you to crash, so practice makes perfect.",
  //     "⚡ Don't be greedy with coins. It's better to miss a few coins than to crash into a train trying to collect them all.",
  //     "⚡ Save your hoverboard for difficult sections. When obstacles are densely packed or trains are coming fast, activate the hoverboard for safety.",
  //     "⚡ Practice sliding under low barriers instead of jumping over them. Sliding is often faster and safer for certain obstacles.",
  //     "⚡ Focus on consistency rather than risky moves. Steady, careful running often beats aggressive, risky strategies.",
  //     "⚡ Watch for warning signals. The game gives visual cues before trains pass, so learn to recognize and react to these warnings."
  //   ],

  //   loveTitle: "Why Train Runner is Perfect for You",
  //   loveDesc: [
  //     "Train Runner stands out in the endless runner category by delivering pure, unadulterated fun without unnecessary complications. The game respects your time with quick sessions that provide complete satisfaction whether you play for two minutes during a break or dedicate an hour to beating your high score. Every run feels rewarding and engaging.",
  //     "Unlike many mobile games that bombard you with ads and aggressive monetization, Train Runner keeps things fair and fun. The game is completely free to play with all features accessible without spending money. Optional ads provide rewards like extra coins or continue options, but they're never forced on you. You can enjoy the full experience without opening your wallet.",
  //     "The game runs smoothly on virtually any smartphone or tablet, from budget devices to high-end flagships. We've optimized every aspect to ensure consistent performance, responsive controls, and stable frame rates. Whether you're playing on an older phone or the latest model, Train Runner delivers the same premium experience that keeps you entertained.",
  //     "Train Runner also serves as an excellent stress reliever and quick entertainment option. Many players report that a few runs help them relax during busy days, clear their minds during breaks, or simply have fun while commuting. The simple yet engaging gameplay provides the perfect balance of challenge and enjoyment."
  //   ],

  //   perfectForTitle: "Perfect Gaming for Everyone",
  //   perfectFor: [
  //     "Train Runner appeals to players of all ages and gaming backgrounds. Children love the colorful graphics and exciting chase gameplay, while adults appreciate the challenging mechanics and competitive scoring system. The game is perfect for quick entertainment during commutes, waiting in lines, or relaxing at home after a long day.",
  //     "Casual gamers will find the controls easy to learn and the gameplay immediately satisfying. Hardcore players will discover depth in perfecting runs, unlocking all characters, and competing for top scores on leaderboards. The game scales beautifully to match your skill level and commitment.",
  //     "Families can enjoy Train Runner together, with parents helping younger children navigate tricky sections while older kids compete to see who can run the farthest. It's a great bonding activity that everyone can participate in and enjoy. The game's universal appeal makes it perfect for any social situation."
  //   ]
  // },
  {
   id: 2,
    name: "Subway Surfers",
    slug: "Subway-surfers",
    shortDesc:"Jump into the most exciting subway escape adventure ever created. Dash through busy train tracks, dodge oncoming trains, and collect coins while running from the inspector. With simple swipe controls and endless running action, every second counts in this heart pounding chase. Navigate through vibrant metro stations, unlock awesome characters, and use powerful boosters to survive longer. Experience smooth gameplay with stunning graphics that bring the subway world to life.",
    title: "Escape the Inspector! Dash Through the Subway Tracks!",
    banner: require("../Assets/images/banner/subway_surfers.jpg"),

    screenshots: [
      { src: require("../Assets/images/train-runner.png"), },
      { src: require("../Assets/images/train-runner2.png"), },
    ],

    welcomeTitle: "Welcome to Subway Surfers",
    intro: [
      "Get ready for the ultimate subway escape adventure with Subway Surfers, one of the most iconic endless runner games ever created! Step into the shoes of a daring graffiti artist sprinting through busy subway tracks, dodging oncoming trains, leaping over barriers, and collecting coins  all while being chased by the grumpy Inspector and his dog.",
      "Subway Surfers is fast, thrilling, and packed with action. Every run takes you through colorful subway stations, railway tracks, tunnels, and vibrant city landscapes. One wrong move and you will crash into a train or obstacle, ending your run instantly! But with sharp reflexes and smart lane switching, you can run endlessly and break your high scores again and again.",
      "What makes Subway Surfers special is its perfect blend of simplicity and challenge. Anyone can start playing instantly thanks to the smooth and intuitive swipe controls. However, mastering the game takes practice and lightning fast decision making. The game gets progressively faster the longer you survive  making every run more exciting than the last."
    ],

    howToPlayTitle: "🔥 Experience the Ultimate Subway Chase",
    howToPlay: [
      "Subway Surfers delivers the most thrilling endless running experience with vibrant, dynamic environments. You’ll dash between subway tracks, jump over trains, slide under barriers, and dodge obstacles while collecting coins and boosters along the way.",
      "Every run feels fresh thanks to randomly generated paths, train patterns, and obstacle arrangements. With each second, the speed increases, pushing your reflexes to the limit. Explore different areas like platforms, tunnels, bridges, and outdoor tracks  each filled with unique visuals and challenges.",
      "Collect coins to unlock cool characters, amazing hoverboards, and special upgrades. With dozens of characters, unique boards, and endless gameplay possibilities, Subway Surfers offers incredible replay value and hours of addictive fun."
    ],

    featuresTitle: "✨ Amazing Game Features",
    features: [
      {
        title: "🚇 Run Through Vibrant Subway Tracks",
        desc: "Dash through beautifully designed subway environments full of trains, urban scenery, and animated surroundings. Every location is colorful and exciting!"
      },
      {
        title: "🎮 Simple Swipe Controls",
        desc: "Swipe up to jump, down to slide, and left or right to switch lanes  easy to learn, impossible to master. The game responds instantly to your swipes for smooth and precise movement."
      },
      {
        title: "🏃 Endless Running",
        desc: "The game continues as long as you can survive. With increasing speed and challenging patterns, every run becomes an intense test of reflexes."
      },
      {
        title: "💰 Coins & Rewards",
        desc: "Collect coins to unlock new characters and boards. Keys allow you to revive after crashing so you can continue your run. Special events provide extra rewards and seasonal characters."
      },
      // {
      //   title: "⚡ Epic Power-Ups",
      //   desc: "Discover amazing power-ups that give you temporary superpowers. Activate jetpacks, hoverboards, shields, and more to help you survive longer and score higher."
      // },
    ],

    tipsTitle: "Pro Tips for Maximum Distance",
    tipsub:"",
    tips: [
      "⚡ Always look ahead. Focus on upcoming trains and obstacles instead of staring at your character.",
      "⚡ Stay in the middle lane by default to give yourself the best flexibility to dodge in any direction.",
      "⚡ Don’t jump too early over barriers  timing is everything.",
      "⚡ Avoid risky coin grabs. Safety first missing a few coins is better than ending your run.",
      "⚡ Use your hoverboard wisely. Activate it during fast or crowded sections to avoid sudden crashes.",
      "⚡ Master sliding under low obstacles. It’s a fast, safe move that can save you in tight situations.",
      "⚡ Grab power ups whenever you can. They greatly increase your survival chances and boost your score.",
      "⚡ Watch for train warning lights. These signals tell you which track will have an incoming train."
    ],

    loveTitle: "Why Subway Surfers Is Perfect for You",
    loveDesc: [
      "Subway Surfers stands out in the endless runner category because it delivers fast, fun, and satisfying gameplay without unnecessary complications. Each run is quick and exciting  whether you have 2 minutes during a break or want to spend an hour chasing high scores, the game always feels rewarding.",
      "The game is completely free to play, with optional ads for rewards like extra coins or second chances. No paywalls, no forced interruptions  just pure gameplay fun. Subway Surfers runs smoothly on all devices, from budget phones to high end models, ensuring a flawless experience wherever you play.",
      "The game is also a great stress reliever. The fast movement, colorful visuals, and satisfying flow help you relax and refresh your mind instantly.",
      // "Train Runner also serves as an excellent stress reliever and quick entertainment option. Many players report that a few runs help them relax during busy days, clear their minds during breaks, or simply have fun while commuting. The simple yet engaging gameplay provides the perfect balance of challenge and enjoyment."
    ],

    perfectForTitle: "Perfect Gaming for Everyone",
    perfectFor: [
      "Subway Surfers appeals to players of all ages. Kids love the colorful graphics and fun characters, while adults enjoy perfecting their reflexes and competing for high scores. It’s perfect for quick entertainment on the go, during commutes, or while relaxing at home.",
      "Families can enjoy the game together parents helping younger kids avoid trains, and older children challenging each other to beat the highest distance. The game’s universal appeal makes it enjoyable for everyone, anytime, anywhere.",
      // "Families can enjoy Train Runner together, with parents helping younger children navigate tricky sections while older kids compete to see who can run the farthest. It's a great bonding activity that everyone can participate in and enjoy. The game's universal appeal makes it perfect for any social situation."
    ]
  },
   {
   id: 3 ,
     name: "Bubble Pop Blast",
    slug: "Bubble Pop Blast",
    shortDesc:"Get ready for colorful bubble popping madness that's impossible to put down. Aim your bubble shooter, match three or more bubbles of the same color, and create amazing chain reactions. With hundreds of carefully designed levels, special boosters, and satisfying pop effects, this classic puzzle game offers the perfect blend of relaxation and challenge. Master bank shots, clear difficult puzzles, and earn three stars on every level. Enjoy offline play anytime, anywhere.",
    title: "Aim, Match, and Pop Your Way to Victory!",
    banner: require("../Assets/images/banner/bubble_pop_blast.jpg"),

    screenshots: [
      { src: require("../Assets/images/pop-blast2.png"),},
      { src: require("../Assets/images/pop-blast.png"),  },
    ],

    welcomeTitle: "Welcome to Bubble Pop Blast!",
    intro: [
      "Get ready for the most colorful and addictive bubble shooting experience ever created! Bubble Pop Blast is a classic puzzle game that combines simple mechanics with challenging gameplay to deliver hours of entertainment. Whether you're a puzzle game veteran or trying bubble shooters for the first time, this game offers the perfect balance of fun and challenge that will keep you coming back for more.",
      "In Bubble Pop Blast, your mission is simple yet incredibly satisfying: aim your bubble shooter at clusters of matching colored bubbles and fire away to create spectacular chain reactions. Match three or more bubbles of the same color to make them pop and disappear. The more bubbles you pop in a single shot, the higher your score climbs. It sounds easy, but as you progress through levels, the challenges become more complex and require strategic thinking",
      "What makes Bubble Pop Blast special is its perfect blend of relaxation and excitement. The game is calming enough to help you unwind after a stressful day, yet engaging enough to keep your mind sharp and focused. With hundreds of carefully designed levels, multiple game modes, and satisfying bubble popping effects, this game delivers an experience that appeals to players of all ages and skill levels."
    ],

    howToPlayTitle: "🔥 Experience Classic Bubble Shooting Fun",
    howToPlay: [
      "Bubble Pop Blast brings you the timeless bubble shooter gameplay you love with modern twists and improvements. Use your finger to aim the bubble cannon, tap to shoot, and watch as matching bubbles burst in colorful explosions. The physics based shooting feels natural and responsive, making every shot satisfying whether you're clearing simple clusters or executing complex bank shots.",
      "Each level presents a unique puzzle configuration that requires different strategies to solve. Some levels challenge you to clear all bubbles within a limited number of shots, while others test your speed with falling ceiling mechanics. The variety ensures that gameplay never feels repetitive, and you'll always encounter fresh challenges that test your puzzle solving abilities.",
      "The game automatically increases speed as you advance, creating an intense challenge that pushes your reflexes to the limit. Collecting coins allows you to unlock new characters, upgrade power ups, and customize your runner. With dozens of characters to unlock and endless gameplay possibilities, Train Runner offers incredible replay value."
    ],

    featuresTitle: "✨ Amazing Game Features",
    features: [
      {
        title: "🎯 Easy to Learn, Hard to Master",
        desc: "Simple tap and shoot controls make the game accessible to everyone. However, mastering advanced techniques like bank shots and strategic bubble placement requires practice and skill."
      },
      {
        title: "🎨 Colorful Graphics",
        desc: "Enjoy vibrant, eye catching visuals with beautifully designed bubbles and backgrounds. Smooth animations and particle effects make every pop feel satisfying and rewarding."
      },
      {
        title: "🏆 Hundreds of Levels",
        desc: "Challenge yourself with hundreds of unique levels, each with different layouts and objectives. From easy warm ups to mind bending puzzles, there's always a new challenge waiting."
      },
      {
        title: "⭐ Star Rating System",
        desc: "Earn up to three stars on each level based on your performance. Perfect scores unlock special rewards and show off your bubble popping mastery to friends."
      },
      {
        title: "🚀 Special Boosters",
        desc: "Use powerful boosters to overcome challenging levels. From rainbow bubbles that match any color to bombs that clear large areas, strategic booster use is key to success."
      },
    ],

    tipsTitle: "Expert Tips for Maximum Pops",
    tipsub:"",
    tips: [
      "🎯 Always aim for the largest clusters of matching bubbles. Clearing big groups gives bonus points and creates better opportunities for future shots.",
      "🎯 Use the walls to your advantage. Bank shots off the side walls can help you reach difficult spots and clear bubbles that seem impossible to hit directly.",
      "🎯 Plan ahead by looking at your next bubble. Knowing what color is coming helps you make smarter decisions about where to place your current shot.",
      "🎯 Focus on creating falling bubbles. When you pop the bubbles holding others up, those disconnected bubbles fall and give you massive bonus points.",
      "🎯 Don't rush your shots. Take time to aim carefully, especially on levels with limited bubbles. Precision beats speed in most situations.",
      "🎯 Save your boosters for genuinely difficult situations. Using them too early wastes valuable resources that could help you later in challenging levels.",
      "🎯 Clear bubbles from the top when possible. This creates more opportunities for chain reactions and falling bubble bonuses.",
      "🎯 Stay calm on difficult levels. Frustration leads to rushed, poor decisions. Take breaks if you're stuck and come back with fresh perspective."
    ],

    loveTitle: "Why Bubble Pop Blast is Perfect for You",
    loveDesc: [
      "Bubble Pop Blast stands out among puzzle games by delivering pure, distilled fun without unnecessary complications. The game respects your time and intelligence with fair challenges that reward skill and strategy rather than forcing you to watch ads or make purchases to progress. Every level is beatable with smart play and patience.",
      "The game works perfectly for any schedule or lifestyle. Play for two minutes during a coffee break to clear a single level, or settle in for an hour long session to conquer multiple worlds. The game saves your progress automatically, so you can always pick up exactly where you left off without losing momentum.",
      "Unlike many mobile puzzle games, Bubble Pop Blast maintains excellent performance across all devices. Whether you're playing on a budget smartphone or premium tablet, the game runs smoothly with responsive controls and consistent frame rates. We've optimized every aspect to ensure everyone gets the same premium experience.",
      "The game also serves as an excellent mental exercise. Studies show that puzzle games help improve focus, problem solving abilities, and hand eye coordination. Many players report that regular sessions help them stay sharp and provide satisfying mental stimulation that feels more productive than mindless entertainment."
    ],

    perfectForTitle: "Perfect for Every Player",
    perfectFor: [
      "Bubble Pop Blast appeals to puzzle fans of all ages and backgrounds. Children love the bright colors and satisfying popping sounds, while adults appreciate the strategic depth and mental challenge. The game is gentle enough for relaxation yet engaging enough to keep your mind active and entertained.",
      "Seniors particularly enjoy Bubble Pop Blast as a brain training activity that's fun rather than feeling like exercise. The clear visuals and simple controls make it accessible, while the progressive difficulty provides appropriate challenges that keep minds sharp without causing frustration.",
      "For families, Bubble Pop Blast offers bonding opportunities as parents and children work together to solve challenging levels. It's a wholesome activity everyone can enjoy, and comparing scores adds friendly competition that brings people together rather than dividing them."
    ]
  },
  //  {
  //  id: 4,
  //   name: "Wormate",
  //   slug: "Wormate",
  //   shortDesc:"Slither into the ultimate multiplayer arena and compete against players worldwide in real time battles. Start as a tiny snake, consume food to grow longer, and use strategic moves to trap opponents. With smooth controls, customizable skins, and intense online gameplay, prove you're the longest snake in the arena. Master circle traps, execute perfect cut offs, and dominate the leaderboards. Experience non stop action with fair competition where skill determines victory.",
  //   title: "Slither, Grow, and Dominate the Arena!",
  //   banner: require("../Assets/images/banner/warmate_game.jpg"),

  //   screenshots: [
  //     { src: require("../Assets/images/snak-battle2.png"),   },
  //     { src: require("../Assets/images/snak-battle.png"),  },
  //   ],

  //   welcomeTitle: "Welcome to Snake Battle!",
  //   intro: [
  //     "Prepare yourself for the most intense and addictive multiplayer snake experience ever created! Snake Battle takes the classic snake game concept and transforms it into a thrilling online arena where you compete against real players from around the world. Your mission is simple yet incredibly challenging: grow your snake as large as possible while avoiding deadly collisions with other snakes and outsmarting your opponents to become the longest snake in the arena.",
  //     "In Snake Battle, you start as a tiny snake in a massive arena filled with colorful dots and power ups. As you consume these items, your snake grows longer and stronger. But here's the twist  you're not alone. Dozens of other players are slithering around the same arena, all trying to become the biggest snake. The game becomes a strategic battle of positioning, timing, and quick reflexes as you navigate through dangerous situations and look for opportunities to eliminate opponents.",
  //     "What makes Snake Battle incredibly addictive is the perfect blend of simple mechanics and complex strategy. Anyone can understand the basic controls within seconds  just swipe or move your finger to control your snake's direction. However, mastering advanced tactics like circling opponents, using boost strategically, and predicting enemy movements takes practice and skill. Every match feels different, offering endless replayability and excitement."
  //   ],

  //   howToPlayTitle: "🔥 Experience Intense Multiplayer Action",
  //   howToPlay: [
  //     "Snake Battle delivers real time multiplayer gameplay where every match is unpredictable and thrilling. You'll face real human opponents with different playstyles  some play aggressively, cutting off other snakes, while others prefer cautious farming and steady growth. Adapting to different opponents and situations is key to survival and success.",
  //     "The game features smooth controls and responsive gameplay that makes every movement feel natural and precise. Whether you're making tight turns to avoid danger or executing perfect circles to trap opponents, the controls respond instantly to your input. The visual design is colorful and vibrant, with your snake featuring customizable skins that make you stand out in the crowded arena.",
  //     "Each match lasts as long as you can survive. Start small and vulnerable, grow into a formidable competitor, and eventually dominate the leaderboard as the longest snake. The satisfaction of eliminating larger opponents and watching your name climb to the top of the scoreboard is unmatched. With quick matches that last anywhere from a few seconds to several minutes, Snake Battle fits perfectly into any schedule."
  //   ],

  //   featuresTitle: "✨ Amazing Game Features",
  //   features: [
  //     {
  //       title: "🌐 Online Multiplayer Arena",
  //       desc: "Battle against real players worldwide in massive arenas. Every opponent is a real person, making each match unique and unpredictable. Climb the leaderboard and prove you're the best."
  //     },
  //     {
  //       title: "🎮 Simple Touch Controls",
  //       desc: "Control your snake with intuitive swipe or joystick controls. The responsive gameplay ensures your snake moves exactly where you want it to go, giving you precise control in intense situations."
  //     },
  //     {
  //       title: "🐍 Grow and Dominate",
  //       desc: "Start as a tiny snake and grow into a massive serpent by collecting food dots. The longer you survive and eat, the bigger you become, increasing your dominance in the arena."
  //     },
  //     {
  //       title: "⚡ Boost Mechanic",
  //       desc: "Use your boost to speed up temporarily, escaping danger or cutting off opponents. Strategic boost usage can turn the tide of battle, but it costs some of your length, so use it wisely."
  //     },
  //     {
  //       title: "🎨 Customizable Skins",
  //       desc: "Unlock and equip dozens of unique snake skins. From classic patterns to crazy designs, express your personality and stand out from the crowd with your favorite look."
  //     },
  //   ],

  //   tipsTitle: "Pro Strategies to Dominate",
  //   tipsub:"",
  //   tips: [
  //     "🎯 When you're small, stay on the outer edges of the arena and focus on eating. Avoid the dangerous center where large snakes battle until you've grown bigger.",
  //     "🎯 The circle trap is your best weapon. When you're longer than an opponent, try to circle around them. Once trapped, they'll eventually hit your body trying to escape.",
  //     "🎯 Use boost strategically, not randomly. Save it for escaping imminent death or securing kills on trapped opponents. Wasting boost means losing precious length.",
  //     "🎯 Always watch your snake's head position relative to other snakes. If an enemy is near your head, that's dangerous. If they're near your body, you're in control.",
  //     "🎯 When an opponent dies, they drop all their mass as food. Position yourself near large snake battles to collect massive amounts of food quickly when someone dies.",
  //     "🎯 Practice the cut off technique. Speed ahead of an opponent and turn sharply in front of them, forcing them to hit your body. This requires perfect timing and positioning.",
  //     "🎯 Use the arena boundaries to your advantage. Cornering opponents against edges limits their escape options and makes trapping easier.",
  //     "🎯 Pay attention to the minimap if available. It helps you track nearby players and avoid getting ambushed by snakes you didn't see coming."
  //   ],

  //   loveTitle: "Why Snake Battle is Perfect for You",
  //   loveDesc: [
  //     "Snake Battle stands out in the multiplayer arena genre by delivering pure competitive fun without pay to win mechanics. Every player starts each match equal, with success determined entirely by skill, strategy, and decision-making. There are no unfair advantages  just you against other players in a test of reflexes and tactical thinking.",
  //     "The game works perfectly for any schedule or gaming session length. Quick matches mean you can play a round or two during a short break, or dedicate an hour to climbing the leaderboards in multiple matches. The instant matchmaking ensures you're always seconds away from intense multiplayer action without long waiting times.",
  //     "Snake Battle also serves as an excellent social gaming experience. Many players enjoy competing with friends to see who can achieve the highest score or longest snake. The spectator friendly gameplay makes it fun to watch others play, and the simple mechanics mean anyone can understand what's happening even if they've never played before.",
  //     "The game runs smoothly across all devices, from basic smartphones to powerful gaming tablets. Optimized performance ensures stable frame rates and responsive controls regardless of your hardware. Whether you're playing on the bus or relaxing at home, Snake Battle delivers the same premium competitive experience."
  //   ],

  //   perfectForTitle: "Perfect for Competitive Players",
  //   perfectFor: [
  //     "Snake Battle appeals to competitive gamers who love skill based challenges and fair competition. Unlike many mobile games with complex mechanics and steep learning curves, Snake Battle is immediately accessible while offering deep strategic gameplay that rewards practice and improvement. You can see yourself getting better with each match.",
  //     "The game is perfect for players who enjoy the thrill of competition without toxic environments. Matches are fast enough that losses don't feel frustrating, and victories feel genuinely earned. The simple mechanics mean there's no excuse  when you win or lose, it's because of your decisions and skills.",
  //     "Casual gamers also find Snake Battle enjoyable because there's no commitment required. Jump in for a quick match whenever you have free time, and leave without penalties or consequences. The pick-up-and-play nature combined with compelling gameplay creates the perfect mobile gaming experience."
  //   ]
  // },
   {
   id: 4,
    name: "Wormate Game",
    slug: "Wormate",
    shortDesc:"Slither into the ultimate multiplayer arena and compete against players worldwide in real time battles. Start as a tiny snake, consume food to grow longer, and use strategic moves to trap opponents. With smooth controls, customizable skins, and intense online gameplay, prove you're the longest snake in the arena. Master circle traps, execute perfect cut offs, and dominate the leaderboards. Experience non stop action with fair competition where skill determines victory.",
    title: "Slither, Grow, and Dominate the Arena!",
    banner: require("../Assets/images/banner/warmate_game.jpg"),

    screenshots: [
      { src: require("../Assets/images/snak-battle2.png"),   },
      { src: require("../Assets/images/snak-battle.png"),  },
    ],

    welcomeTitle: "Welcome to Wormate",
    intro: [
      "Get ready for one of the most addictive and action packed snake games ever created! Wormate brings you into a fast paced multiplayer arena where you battle against other worms, grow as large as possible, and try to dominate the entire battlefield. The goal is simple: eat, grow, survive, and become the biggest worm in the arena  but achieving this is far more challenging than it sounds.",
      "In Wormate, you begin as a tiny worm slithering through a massive world filled with delicious treats, candy, cakes, cookies, and special power ups. As you eat, your worm grows longer and stronger. But you're not alone  dozens of other players are on the same mission. The arena quickly becomes a battlefield of clever traps, sudden turns, and high speed chases.",
      "The magic of Wormate lies in its perfect blend of easy controls and deep strategy. Anyone can play the game within seconds  just swipe or drag to change direction. But becoming a master requires perfect timing, smart positioning, and tactical thinking. Every match feels exciting and unpredictable, offering endless replayability."
    ],

    howToPlayTitle: "🔥 Experience Intense Multiplayer Action",
    howToPlay: [
      "Wormate offers real time multiplayer gameplay where every match feels different. You’ll face opponents of all skill levels  some aggressive and fearless, others cautious and strategic. This variety makes every moment in the arena thrilling and full of surprises.",
      "The controls are smooth and responsive, allowing you to make tight turns, perfect traps, and clever escapes. Whether you're circling an opponent or boosting past danger, your worm moves precisely where you want it to go.",
      "The visuals are colorful, vibrant, and full of charm. Food items sparkle across the arena, worms move fluidly, and customizable skins allow you to express your personality. From cute patterned worms to flashy neon designs, you can choose the look that suits your style.",
      "Each match lasts as long as you can survive. Start small, grow stronger, trap other worms, and climb the leaderboard. The joy of taking down a huge worm and absorbing its entire mass is unforgettable  and every match gives you a chance to rise to the top."
    ],

    featuresTitle: "✨ Amazing Game Features",
    features: [
      {
        title: "🌐 Online Multiplayer Arena",
        desc: "Compete against real players in giant arenas filled with food, power ups, and danger. Every match is unique and unpredictable, challenging your skills and tactics."
      },
      {
        title: "🎮 Simple Touch & Swipe Controls",
        desc: "Control your worm effortlessly using swipe or joystick movement. The game responds instantly, giving you complete control in fast and intense situations."
      },
      {
        title: "🐍 Eat, Grow & Conquer",
        desc: "Start small and grow by consuming food scattered throughout the arena. The bigger you get, the more power you have to trap and eliminate opponents."
      },
      {
        title: "⚡ Boost to Outsmart Opponents",
        desc: "Use your boost to make quick escapes or cut off enemies. Boosting costs length, so use it carefully  the right boost at the right time can change everything."
      },
      {
        title: "🎨 Customizable Worm Skins",
        desc: "Unlock fun and creative skins to make your worm stand out. Choose from colorful patterns, cute designs, and bold styles to express your personality."
      },
    ],

    tipsTitle: "Pro Strategies to Dominate Wormate",
    tipsub:"",
    tips: [
      "🎯 Avoid the crowded center of the arena until you've grown bigger. The outer areas give you more food and fewer threats.",
      "🎯 Once you're long enough, loop around opponents to trap them. With patience and precision, they'll hit your body trying to escape.",
      "🎯 Boost only when necessary  for escaping danger or securing a kill. Wasting boost shrinks your worm and puts you at risk.",
      "🎯 When a big worm dies, rush to the food drop but stay alert. Many players flock to these spots, and danger increases.",
      "🎯 Boost ahead of an opponent and turn sharply in front of them. If done correctly, they’ll crash into you instantly.",
      "🎯 Cornering opponents near boundaries limits their escape options, making your traps even more effective.",
      "🎯 If available, the minimap helps you track activity and avoid sudden ambushes.",
    ],

    loveTitle: "Why Wormate Is Perfect for You",
    loveDesc: [
      "Wormate stands out thanks to its pure skill based gameplay and fair competitive environment. Every player starts equally, and your success depends only on your decisions, reflexes, and tactics. No pay to win advantages  just skill, strategy, and fun.",
      "Instant matchmaking ensures you jump straight into action without waiting. Whether you want a 30 second game or a 30 minute domination session, Wormate fits perfectly into your schedule.",
      "Wormate is also a great social experience. Compete with friends, challenge each other for high scores, or watch each other’s gameplay  it’s fun to play and fun to watch.",
      "The game is optimized for all devices, from budget phones to high performance tablets. Smooth animations, stable frame rates, and responsive controls ensure a flawless experience no matter where you play."
    ],

    perfectForTitle: "Perfect for Competitive & Casual Players",
    perfectFor: [
      "Wormate appeals to both casual players who want simple fun and competitive players who love skill based games.",
      "The game rewards practice  the more you play, the better you become. Wins feel satisfying, and losses feel like lessons, not punishments.",
      "It’s the perfect blend of fun, challenge, and strategy."
    ]
  },
]
